/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const SupportIcon = ({ width, height }) => {
  return (
    <svg
      className="animated"
      id="freepik_stories-team-spirit"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            'svg#freepik_stories-team-spirit:not(.animated) .animable {opacity: 0;}svg#freepik_stories-team-spirit.animated #freepik--background-complete--inject-211 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-team-spirit.animated #freepik--Floor--inject-211 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-team-spirit.animated #freepik--character-4--inject-211 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-team-spirit.animated #freepik--character-3--inject-211 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-team-spirit.animated #freepik--character-1--inject-211 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-team-spirit.animated #freepik--character-2--inject-211 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}            @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }        ',
        }}
      />
      <g
        id="freepik--background-complete--inject-211"
        style={{ transformOrigin: '253.91770553588867px 252.37126922607422px' }}
        className="animable"
      >
        <rect
          x="349.43"
          y="56.87"
          width="70.31"
          height="101.91"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '384.58500000000004px 107.82499999999999px',
          }}
          id="elh1k2koaqcje"
          className="animable"
        />
        <rect
          x="345.91"
          y="56.87"
          width="70.31"
          height="101.91"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '381.06500000000005px 107.82499999999999px',
          }}
          id="el2q92q0omqp"
          className="animable"
        />
        <rect
          x="354.65"
          y="67.9"
          width="52.84"
          height="79.84"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '381.07px 107.82000000000001px',
          }}
          id="elmto46czp4h"
          className="animable"
        />
        <path
          d="M407.49,147.74s0-.13,0-.39v-1.13c0-1,0-2.47,0-4.38,0-3.83,0-9.4-.05-16.45,0-14.07,0-34-.09-57.49l.18.18H354.65l.19-.19c0,30.12,0,57.89,0,79.84l-.15-.15,38.46.08,10.62,0h2.79l1,0-.93,0h-2.77l-10.59,0-38.55.08h-.16v-.15c0-22,0-49.72,0-79.84v-.19h.19l52.84,0h.17v.17c0,23.53-.06,43.5-.08,57.61,0,7,0,12.59-.05,16.4,0,1.9,0,3.35,0,4.35,0,.48,0,.85,0,1.11S407.49,147.74,407.49,147.74Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '381.1600341796875px 107.6500015258789px',
          }}
          id="el0zl8699stsx"
          className="animable"
        />
        <path
          d="M416.42,56.87a13.48,13.48,0,0,1-1.25,1.82c-.82,1.09-2,2.57-3.3,4.18s-2.56,3-3.48,4a13.36,13.36,0,0,1-1.54,1.58,13.12,13.12,0,0,1,1.34-1.76l3.38-4.1L415,58.52A13,13,0,0,1,416.42,56.87Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '411.63502502441406px 62.65999412536621px',
          }}
          id="elnxxpihj1r0b"
          className="animable"
        />
        <path
          d="M407.76,147.48A65.22,65.22,0,0,0,417,159"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '412.3800048828125px 153.24000549316406px',
          }}
          id="elcre5et2dszt"
          className="animable"
        />
        <path
          d="M417,159a10.44,10.44,0,0,1-1.6-1.46,49.11,49.11,0,0,1-3.48-3.92,50.28,50.28,0,0,1-3.06-4.26,9.69,9.69,0,0,1-1.07-1.89,15.28,15.28,0,0,1,1.29,1.74c.78,1.09,1.87,2.58,3.14,4.17s2.48,3,3.37,4A14.86,14.86,0,0,1,417,159Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '412.3949890136719px 153.2350082397461px',
          }}
          id="el3rd1i9eg0qk"
          className="animable"
        />
        <path
          d="M345.9,158.7l9.21-11.36"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '350.50498962402344px 153.0199966430664px',
          }}
          id="el0ahq7d98zl7d"
          className="animable"
        />
        <path
          d="M355.11,147.34a71.31,71.31,0,0,1-4.46,5.8,71,71,0,0,1-4.75,5.56,67.47,67.47,0,0,1,4.46-5.8A68.84,68.84,0,0,1,355.11,147.34Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '350.50498962402344px 153.01998901367188px',
          }}
          id="elgpvitp8sr3e"
          className="animable"
        />
        <path
          d="M345.91,56.87a61,61,0,0,1,4.47,5.34,64.89,64.89,0,0,1,4.17,5.58,65.18,65.18,0,0,1-4.47-5.34A67.54,67.54,0,0,1,345.91,56.87Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '350.2300109863281px 62.32999610900879px',
          }}
          id="el1otfmcmfp1e"
          className="animable"
        />
        <rect
          x="373.33"
          y="84.11"
          width="17.69"
          height="50.24"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '382.175px 109.23px',
          }}
          id="elc6747bqzlv"
          className="animable"
        />
        <polygon
          points="239.47 45.85 239.47 112.06 144.37 112.06 140.94 46.31 239.47 45.85"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '190.2050018310547px 78.95499801635742px',
          }}
          id="el6d4zf65wi1x"
          className="animable"
        />
        <g id="elz3nptwv35c">
          <rect
            x="155.69"
            y="31.57"
            width="65.61"
            height="95.1"
            style={{
              fill: 'rgb(255, 255, 255)',
              transformOrigin: '188.495px 79.12px',
              transform: 'rotate(-90deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M236.5,112.38h-96V45.86h96Zm-95.11-.91h94.2V46.76h-94.2Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '188.5px 79.11999893188477px',
          }}
          id="elbxmoyax8jgk"
          className="animable"
        />
        <rect
          x="151.24"
          y="54.46"
          width="74.5"
          height="49.31"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '188.49px 79.11500000000001px',
          }}
          id="el9g55mvx1gho"
          className="animable"
        />
        <path
          d="M225.74,54.46l-.36,0h-1.06l-4.09,0-15.36,0-53.63.11.22-.22c0,15.07,0,31.76,0,49.31h0l-.24-.23,74.5,0-.18.18c0-15,.07-27.31.1-35.87,0-4.29,0-7.63,0-9.92,0-1.14,0-2,0-2.61s0-.91,0-.91,0,.29,0,.87,0,1.45,0,2.57c0,2.28,0,5.62,0,9.88,0,8.6.06,20.94.1,36V104h-.19l-74.5.05H151v-.24h0c0-17.55,0-34.24,0-49.31v-.21h.21l53.77.1,15.31.06,4.05,0h1.37Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '188.37001037597656px 79.17000389099121px',
          }}
          id="el76emqt7eb2d"
          className="animable"
        />
        <path
          d="M140.94,46.13a7.85,7.85,0,0,1,1.64,1.06c1,.7,2.29,1.7,3.73,2.84s2.68,2.23,3.57,3a7.88,7.88,0,0,1,1.36,1.39c-.09.1-2.37-1.78-5.23-4.06A52,52,0,0,1,140.94,46.13Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '146.09000396728516px 50.276904582977295px',
          }}
          id="elvax61m0nhw"
          className="animable"
        />
        <path
          d="M236,46.31a46.46,46.46,0,0,1-5,4.26,44.41,44.41,0,0,1-5.3,3.89,47.38,47.38,0,0,1,5-4.26A46.25,46.25,0,0,1,236,46.31Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '230.85000610351562px 50.38499450683594px',
          }}
          id="el1lwabo9g01r"
          className="animable"
        />
        <path
          d="M236,111.93l-10.6-8.59"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '230.6999969482422px 107.6349983215332px',
          }}
          id="el3llghz8arya"
          className="animable"
        />
        <path
          d="M225.37,103.34a49.73,49.73,0,0,1,5.44,4.11,51.33,51.33,0,0,1,5.16,4.48,50.35,50.35,0,0,1-5.45-4.11A47.83,47.83,0,0,1,225.37,103.34Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '230.6699981689453px 107.6349983215332px',
          }}
          id="el98c64i05gz"
          className="animable"
        />
        <path
          d="M140.94,111.92a46.78,46.78,0,0,1,4.95-4.21,45.37,45.37,0,0,1,5.25-3.85,45.69,45.69,0,0,1-5,4.22A44,44,0,0,1,140.94,111.92Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '146.04000091552734px 107.88999938964844px',
          }}
          id="elttavd3avmui"
          className="animable"
        />
        <g id="elpxnejtsstif">
          <rect
            x="181.55"
            y="54.64"
            width="16.51"
            height="46.88"
            style={{
              fill: 'rgb(224, 224, 224)',
              transformOrigin: '189.805px 78.08px',
              transform: 'rotate(-90deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M62.53,432.48c.94-3.71-1.51-7.41-4.25-10.08s-6-5.06-7.43-8.6c-2.33-5.74.71-13.21-3.23-18-2.32-2.81-6.45-3.74-8.51-6.74a15.45,15.45,0,0,1-1.87-5.38,54.7,54.7,0,0,0-13.76-25.4A47.5,47.5,0,0,0,29,382.82c1.6,3,3.57,5.94,4.11,9.31.88,5.46-2.14,11.11-.76,16.47,1.57,6.14,8.49,10.21,8.85,16.53.31,5.34-4.32,10.06-3.94,15.39a14.36,14.36,0,0,0,2.41,6.33c4.17,6.84,10.27,11.54,19.47,11.34l11.27.33Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '46.91909599304199px 408.40000915527344px',
          }}
          id="el0fvd7rxsok55"
          className="animable"
        />
        <path
          d="M72.65,458.8a9.11,9.11,0,0,0,3.11-.09,18,18,0,0,0,3.65-.94,15.55,15.55,0,0,0,4.51-2.5,6.36,6.36,0,0,0,1.85-2.49,11.59,11.59,0,0,0,.51-3.37,32.87,32.87,0,0,1,.24-3.65,10.25,10.25,0,0,1,1.36-3.63c1.31-2.34,3.51-4.56,4.2-7.74s.18-6.49-.36-9.87-1.07-7.06.2-10.59,3.65-6.73,4.86-10.71.61-8.33.84-12.59a16.72,16.72,0,0,1,1.44-6.27c.9-2,2.15-3.89,3.13-6,2-4.26,2.3-9.07,2.82-13.79q.38-3.57.77-7.21a34.61,34.61,0,0,1,1.21-7.21,63.26,63.26,0,0,1,2.65-7,21.58,21.58,0,0,0,1.29-3.65,34.27,34.27,0,0,0,.34-3.88,45.37,45.37,0,0,0-.34-7.8c-.32-2.6-.81-5.17-1.1-7.78,0-.15,0-.31,0-.45l-.06-.52-.46.24a17.31,17.31,0,0,0-6,5.15,27.62,27.62,0,0,0-3.69,6.89c-1.86,4.86-2.5,9.93-3.43,14.78s-2.09,9.62-4.55,13.66c-1.22,2-2.71,3.85-4,5.82a15.79,15.79,0,0,0-2.76,6.44c-.64,4.77,2,8.94,1.48,13.16a14.47,14.47,0,0,1-2,5.86c-1,1.81-2.2,3.49-3.34,5.17a33.15,33.15,0,0,0-3,5.22,16.49,16.49,0,0,0-1.35,5.66c-.26,3.8.3,7.4,0,10.81a25,25,0,0,1-2.72,9.27C72.54,430,71,432.52,69.78,435c-.63,1.22-1.22,2.41-1.69,3.6a18.09,18.09,0,0,0-1,3.57,22.39,22.39,0,0,0,0,6.43,16.16,16.16,0,0,0,3.27,8.19,8.94,8.94,0,0,0,.91,1,4.59,4.59,0,0,0,.75.62c.42.31.64.45.64.45a14.37,14.37,0,0,1-2.19-2.15,16.34,16.34,0,0,1-3.11-8.13,22.66,22.66,0,0,1,.11-6.34,17.16,17.16,0,0,1,1-3.48,36.8,36.8,0,0,1,1.7-3.55c1.26-2.42,2.78-4.93,4.16-7.73A25.14,25.14,0,0,0,77.12,418c.28-3.48-.26-7.09,0-10.8a16,16,0,0,1,1.33-5.47,32.21,32.21,0,0,1,3-5.11c1.13-1.68,2.34-3.36,3.38-5.2a15.31,15.31,0,0,0,2.12-6.1c.52-4.5-2.12-8.7-1.46-13.14A15.37,15.37,0,0,1,88.11,366c1.28-1.93,2.77-3.77,4-5.83,2.54-4.16,3.75-9,4.66-13.89s1.58-9.9,3.4-14.65a26.81,26.81,0,0,1,3.6-6.71,16.6,16.6,0,0,1,5.78-4.94l-.52-.29c0,.14,0,.3,0,.46.3,2.63.78,5.21,1.1,7.78a45,45,0,0,1,.34,7.68,34.84,34.84,0,0,1-.32,3.76,22.41,22.41,0,0,1-1.25,3.52,64.87,64.87,0,0,0-2.67,7.07,36.12,36.12,0,0,0-1.23,7.33c-.25,2.43-.51,4.84-.76,7.22-.51,4.73-.84,9.47-2.74,13.58-.94,2.05-2.19,3.94-3.12,6a17.55,17.55,0,0,0-1.47,6.5c-.22,4.35.37,8.6-.79,12.46s-3.58,7.05-4.81,10.7-.73,7.48-.17,10.85,1.12,6.69.41,9.69-2.76,5.23-4.1,7.64a10.42,10.42,0,0,0-1.38,3.78,31.74,31.74,0,0,0-.21,3.69,11.63,11.63,0,0,1-.47,3.27,6,6,0,0,1-1.73,2.39,15.6,15.6,0,0,1-4.4,2.51,18.94,18.94,0,0,1-3.61,1,14.37,14.37,0,0,1-2.29.24C72.92,458.79,72.65,458.8,72.65,458.8Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '89.08454895019531px 388.98130798339844px',
          }}
          id="elbl9yrmz2zu"
          className="animable"
        />
        <path
          d="M107.51,325.83a1.4,1.4,0,0,0-.11.34q-.09.4-.24,1c-.22.89-.47,2.23-.89,3.91s-1.44,3.56-2.31,5.9-1.8,5-2.63,8-1.58,6.36-2.36,9.94-1.6,7.4-3.55,11c-.91,1.84-1.94,3.7-2.75,5.73a26.49,26.49,0,0,0-1.59,6.48,132.58,132.58,0,0,1-2.35,13.64c-2.21,9.25-4.31,18.06-6.23,26.08l-5.22,21.27c-1.44,6-2.62,10.9-3.45,14.35-.39,1.66-.69,3-.91,3.91l-.22,1a1.85,1.85,0,0,0,0,.35s.06-.11.13-.34.17-.59.28-1c.26-.94.6-2.24,1-3.88.88-3.43,2.14-8.3,3.68-14.3s3.35-13.25,5.37-21.23,4.06-16.83,6.29-26.08a128.94,128.94,0,0,0,2.34-13.71,26.08,26.08,0,0,1,1.53-6.32c.78-2,1.8-3.83,2.71-5.68,2-3.69,2.77-7.64,3.54-11.2s1.46-6.92,2.26-9.92,1.67-5.69,2.52-8,1.8-4.24,2.2-6,.59-3.05.76-3.95c.07-.42.13-.76.17-1A1.41,1.41,0,0,0,107.51,325.83Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '90.10085868835449px 392.2799987792969px',
          }}
          id="elscyzskzzxv"
          className="animable"
        />
        <path
          d="M74.64,458.82C82,454.41,84,441.11,80.9,433.14s-8.53-15.25-9.41-23.77c-.67-6.55,1.43-13.29-.13-19.68-2.11-8.63-10.58-15.28-10.53-24.16,0-5,2.83-9.69,2.58-14.67-.31-6.11-5-10.93-8-16.29C51,326.36,50.61,316.62,49,307.4s-5.14-19.1-13.35-23.59c-1.17,7.85-3.2,13.23-2.49,23.85.25,3.81,4.73,11.09,5.38,19.44.38,5,.66,10,1,15s.66,9.81,2.43,14.36c1.36,3.48,3.53,6.63,4.54,10.23,1.9,6.76-.51,14.12,1,21,1.31,5.81,5.36,10.79,6.22,16.69,1.2,8.27-4.11,16.91-1.32,24.8,1.38,3.92,4.63,7.05,5.56,11.09.73,3.14,0,6.47.64,9.62,1.06,5.08,10.79,9,16,8.63"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '57.65949630737305px 371.31500244140625px',
          }}
          id="elh3qrgt8o2m"
          className="animable"
        />
        <path
          d="M37.75,291.58a2.09,2.09,0,0,0,0,.44c0,.33.1.76.17,1.29.17,1.13.37,2.8.77,4.94s1.55,4.59,2.46,7.52,1.91,6.29,2.75,10.06,1.59,7.95,2.35,12.45,1.6,9.39,3.86,14.06c1,2.35,2.22,4.7,3.1,7.2a32.7,32.7,0,0,1,1.6,7.95,160.43,160.43,0,0,0,2.25,17.13c2.32,11.6,4.53,22.66,6.55,32.72s4,19,5.63,26.64,2.93,13.66,3.85,17.95c.47,2.08.83,3.71,1.09,4.87.12.53.22.94.3,1.27a2.16,2.16,0,0,0,.12.42,1.34,1.34,0,0,0,0-.44c-.06-.32-.13-.75-.23-1.28-.23-1.16-.55-2.81-1-4.9-.87-4.29-2.11-10.43-3.63-18s-3.42-16.65-5.48-26.68-4.19-21.11-6.48-32.71a161.59,161.59,0,0,1-2.27-17.08,32.74,32.74,0,0,0-1.65-8.1c-.91-2.56-2.1-4.92-3.14-7.24-2.25-4.61-3.06-9.42-3.87-13.9s-1.55-8.67-2.45-12.45a104.07,104.07,0,0,0-2.87-10.08c-1-2.94-2.11-5.34-2.57-7.45s-.68-3.78-.9-4.9L37.86,292A2.42,2.42,0,0,0,37.75,291.58Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '56.178279876708984px 375.0350341796875px',
          }}
          id="elrc9oorr01os"
          className="animable"
        />
        <path
          d="M419.84,446c-18.29-10.87-23.89-33.12-24.7-53.43-.14-3.39-.77-6.93.62-10s5-5.39,8.13-4.19c2.6,1,3.91,3.84,5.49,6.15a19.86,19.86,0,0,0,8.49,7c2.24,1,4.95,1.45,7,.12,2.8-1.83,2.85-5.88,2.58-9.25q-.75-9.39-1.51-18.8c-.26-3.36-.53-6.8.28-10.07s2.91-6.4,6-7.54,7.23.42,8.15,3.67a30.5,30.5,0,0,1,.4,4.18c.2,1.39,1,2.89,2.32,3.18s2.65-.76,3.58-1.82c3.22-3.65,5.25-8.2,7.14-12.72s3.68-9.12,6.56-13.06,7-7.2,11.82-7.83,10.15,2,11.72,6.61-.84,9.67-3.57,13.73A75.34,75.34,0,0,1,465.83,358a6.18,6.18,0,0,0-2.4,3c-.57,2.29,1.72,4.36,4,4.94,2.57.65,5.27.19,7.92.3s5.57,1.06,6.74,3.47c1.64,3.34-1,7.15-3.63,9.72a64.47,64.47,0,0,1-18.23,12.4c-2.4,1.09-5,2.07-6.82,4s-2.85,5-1.47,7.28,4.54,2.81,7.09,2.14,4.78-2.25,7.18-3.37c4.49-2.08,10.49-2.2,13.74,1.57,2.14,2.49,2.58,6.13,1.83,9.33a24.56,24.56,0,0,1-4.49,8.7,64.79,64.79,0,0,1-26.18,21.45c-10.45,4.51-20.32,6.25-31.26,3.14"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '439.64171981811523px 384.56999588012695px',
          }}
          id="eldret4ta77ho"
          className="animable"
        />
        <path
          d="M423.14,447c.15-8.08-1.26-3.6,1-14a302.57,302.57,0,0,1,9.57-33.34c1-2.91,2-5.78,3-8.61s1.94-5.63,3.06-8.31a151.11,151.11,0,0,1,7.3-15c2.55-4.67,5.15-9,7.6-13s4.83-7.75,7.14-11.05a118.64,118.64,0,0,1,12-14.73c1.55-1.62,2.79-2.84,3.64-3.66l1-.92a3.63,3.63,0,0,1,.35-.3,3.14,3.14,0,0,1-.31.35l-.93,1c-.82.85-2,2.09-3.56,3.74a126.21,126.21,0,0,0-11.82,14.82c-2.28,3.3-4.62,7-7.06,11.06s-5,8.39-7.54,13.06a152.41,152.41,0,0,0-7.24,15c-1.11,2.67-2.06,5.44-3,8.27s-2,5.71-2.95,8.61a309,309,0,0,0-9.6,33.26c-2.27,10.4-.91,5.88-1.11,13.93"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '450.82092094421387px 385.63002014160156px',
          }}
          id="elao4704pe85"
          className="animable"
        />
        <path
          d="M439.89,382.64a7,7,0,0,1-.43-1.41c-.25-.91-.56-2.25-.92-3.91-.72-3.31-1.56-7.92-2.47-13s-1.82-9.68-2.59-13c-.38-1.65-.7-3-.93-3.9a6.93,6.93,0,0,1-.3-1.45,6.75,6.75,0,0,1,.53,1.38c.3.9.69,2.22,1.13,3.86.88,3.28,1.86,7.87,2.77,13s1.68,9.56,2.29,13c.29,1.57.53,2.89.73,3.95A6.3,6.3,0,0,1,439.89,382.64Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '436.07000732421875px 364.30499267578125px',
          }}
          id="elbyf0mixhp9r"
          className="animable"
        />
        <path
          d="M482.55,371.37a9.18,9.18,0,0,1-1.71.33c-1.1.18-2.7.44-4.66.81-3.93.72-9.32,1.91-15.22,3.47s-11.16,3.24-14.94,4.55c-1.9.64-3.42,1.2-4.47,1.58a9,9,0,0,1-1.66.53,9.87,9.87,0,0,1,1.57-.76c1-.45,2.53-1.08,4.41-1.77,3.75-1.42,9-3.15,14.93-4.73a151.7,151.7,0,0,1,15.31-3.31c2-.32,3.59-.51,4.7-.61A8.45,8.45,0,0,1,482.55,371.37Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '461.2200012207031px 376.9993600845337px',
          }}
          id="eldgztyzhg74"
          className="animable"
        />
        <path
          d="M424.6,432.1a2.15,2.15,0,0,1-.33-.5c-.24-.41-.52-.91-.86-1.51-.74-1.32-1.75-3.25-3-5.65-2.45-4.8-5.63-11.54-9-19s-6.52-14.25-8.87-19.09c-1.15-2.36-2.09-4.3-2.8-5.73L399,379a1.89,1.89,0,0,1-.22-.56,2.64,2.64,0,0,1,.33.5c.23.41.51.91.86,1.51.73,1.32,1.75,3.25,3,5.65,2.46,4.8,5.64,11.54,9,19s6.53,14.25,8.87,19.09c1.16,2.36,2.1,4.29,2.8,5.73.31.63.55,1.14.76,1.57A2.34,2.34,0,0,1,424.6,432.1Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '411.6900177001953px 405.27000427246094px',
          }}
          id="elj9noushmd7"
          className="animable"
        />
        <path
          d="M480.71,409.33a2,2,0,0,1-.55.28l-1.63.68c-1.5.62-3.53,1.45-6,2.45-5.07,2.07-12,5-19.74,8.27s-14.71,6.13-19.83,8.1c-2.56,1-4.64,1.75-6.08,2.26l-1.67.57a2.09,2.09,0,0,1-.6.16,2.86,2.86,0,0,1,.55-.28l1.63-.68,6-2.45c5.07-2.07,12-5,19.75-8.26s14.71-6.14,19.82-8.1c2.56-1,4.64-1.76,6.09-2.26l1.67-.58A2.51,2.51,0,0,1,480.71,409.33Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '452.66001892089844px 420.7149963378906px',
          }}
          id="elc3uba6v4hf"
          className="animable"
        />
      </g>
      <g
        id="freepik--Floor--inject-211"
        style={{ transformOrigin: '251.2349853515625px 456.2099914550781px' }}
        className="animable"
      >
        <path
          d="M470.58,456.21c0,.14-98.21.26-219.33.26s-219.36-.12-219.36-.26,98.19-.26,219.36-.26S470.58,456.07,470.58,456.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '251.2349853515625px 456.2099914550781px',
          }}
          id="elthmqtbhn8f"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-4--inject-211"
        style={{ transformOrigin: '368.55152893066406px 269.42325592041016px' }}
        className="animable"
      >
        <path
          d="M387.34,99.08c-7.17-3.08-15.51,1.32-18.73,6.2S364,116,363.08,121.8a135.91,135.91,0,0,0-.88,36c.38,3.53,1.07,7.37,3.77,9.68s6.3,2.38,9.62,1.8c3-.52,6.05-1.66,8-4,3-3.59,2.61-8.81,2.29-13.48a139.85,139.85,0,0,1,5-47.81"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '376.1409044265747px 133.82086563110352px',
          }}
          id="elhbcc3ulkpy6"
          className="animable"
        />
        <path
          d="M371.71,105.6C375,99.06,385,95.53,393.08,97.72c6.82,1.84,14.11,8.84,14.61,16,.71,10.44-4.93,21.1-1.59,31,3.89,11.54,18.21,17.13,21.87,28.74A18.28,18.28,0,0,1,426.4,188c-1.29,2.23-3.26,4.29-5.81,4.71-3.17.51-6.1-1.62-8.6-3.64-6.77-5.44-13.65-11-18.37-18.3-5.55-8.59-7.69-19-7.78-29.26s1.74-20.37,3.56-30.43"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '400.25902938842773px 144.92864227294922px',
          }}
          id="elnaedtxl6rwq"
          className="animable"
        />
        <path
          d="M400.24,118.27A15.41,15.41,0,0,0,386.39,101c-8.21-.78-15.52,5.34-16.75,13.5-1.08,7.15-2,14.38-2,17,.1,7.91,4.73,11,6.6,11.91a10.56,10.56,0,0,0,2.08.52h0a.06.06,0,0,1,0,.06l-1.76,9.08c-.8,5.95,2.53,11.25,8.46,12.12s10.62-3.7,11.53-9.65Z"
          style={{
            fill: 'rgb(147, 103, 84)',
            transformOrigin: '384.0005359649658px 133.11474609375px',
          }}
          id="elzk9rv38yuo"
          className="animable"
        />
        <path
          d="M371.47,118.44a1.26,1.26,0,0,0,1,1.43,1.22,1.22,0,0,0,1.45-.94,1.27,1.27,0,0,0-1-1.43A1.2,1.2,0,0,0,371.47,118.44Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '372.6943118572235px 118.6830061674118px',
          }}
          id="elxk1eww0hirp"
          className="animable"
        />
        <path
          d="M371.47,116.66c.13.18,1.17-.38,2.51-.18s2.22,1,2.39.87,0-.38-.41-.75a3.42,3.42,0,0,0-1.89-.9,3.34,3.34,0,0,0-2,.34C371.58,116.3,371.4,116.57,371.47,116.66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '373.9454333782196px 116.51572167873383px',
          }}
          id="elxvclceul52o"
          className="animable"
        />
        <path
          d="M384.14,120.49a1.26,1.26,0,0,0,1,1.43,1.2,1.2,0,0,0,1.45-.93,1.25,1.25,0,0,0-1-1.43A1.2,1.2,0,0,0,384.14,120.49Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '385.36573004722595px 120.74000370502472px',
          }}
          id="el57kwlki2w66"
          className="animable"
        />
        <path
          d="M384.59,118.82c.13.19,1.18-.37,2.51-.17s2.23,1,2.4.87,0-.38-.42-.76a3.49,3.49,0,0,0-1.88-.89,3.31,3.31,0,0,0-2,.34C384.71,118.47,384.53,118.74,384.59,118.82Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '387.07205963134766px 118.6851994395256px',
          }}
          id="eljwd3vr1ykt9"
          className="animable"
        />
        <path
          d="M378.28,128a9.15,9.15,0,0,0-2.11-.71c-.34-.08-.65-.2-.68-.44a1.85,1.85,0,0,1,.38-1c.44-.78.9-1.6,1.39-2.45a45.41,45.41,0,0,0,3.26-6.48,45.3,45.3,0,0,0-3.77,6.2c-.48.86-.93,1.69-1.35,2.48A2,2,0,0,0,375,127a.87.87,0,0,0,.49.58,2.12,2.12,0,0,0,.57.17A8.46,8.46,0,0,0,378.28,128Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '377.7555854320526px 122.46086502075195px',
          }}
          id="el6t4s1c3begh"
          className="animable"
        />
        <path
          d="M376.41,144s5.11,1.17,12.14-1.77c0,0-3,6.54-12.62,4.21Z"
          style={{
            fill: 'rgb(124, 81, 66)',
            transformOrigin: '382.2400207519531px 144.58590269088745px',
          }}
          id="elkfqa0vjc3w"
          className="animable"
        />
        <path
          d="M378.38,131.35a2.45,2.45,0,0,1,2.29-.58,2.27,2.27,0,0,1,1.41,1,1.41,1.41,0,0,1-.13,1.61,1.64,1.64,0,0,1-1.82.19,5.29,5.29,0,0,1-1.56-1.27,1.58,1.58,0,0,1-.33-.45.47.47,0,0,1,.08-.5"
          style={{
            fill: 'rgb(124, 81, 66)',
            transformOrigin: '380.2369887828827px 132.22602713108063px',
          }}
          id="elwc8f9p1xpen"
          className="animable"
        />
        <path
          d="M382.09,129.54c-.22,0-.43,1.41-1.83,2.26s-2.91.47-2.95.67.3.33.95.45a3.7,3.7,0,0,0,2.46-.48,3.21,3.21,0,0,0,1.44-1.91C382.3,129.93,382.19,129.55,382.09,129.54Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '379.7665672302246px 131.25155186653137px',
          }}
          id="eluvof9na10en"
          className="animable"
        />
        <path
          d="M384.33,116.39c.08.38,1.44.41,3,.83s2.76,1,3,.73c.12-.14-.05-.52-.51-.94a5.1,5.1,0,0,0-2.15-1.12,5.15,5.15,0,0,0-2.42-.07C384.63,116,384.3,116.21,384.33,116.39Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '387.3476548194885px 116.8638551235199px',
          }}
          id="el39ogpkxol8q"
          className="animable"
        />
        <path
          d="M372.36,114c.19.34,1.16.16,2.27.31s2,.5,2.28.21,0-.46-.36-.81a3.13,3.13,0,0,0-1.77-.77,3.09,3.09,0,0,0-1.89.35C372.45,113.53,372.28,113.83,372.36,114Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '374.6824584007263px 113.77207839488983px',
          }}
          id="elqzov736gdu"
          className="animable"
        />
        <path
          d="M375.79,102A16.33,16.33,0,0,0,387.08,115l-.45-2.24a23,23,0,0,0,12.48,11.09,15.82,15.82,0,0,0-23.25-20.59"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '388.54538440704346px 111.92442512512207px',
          }}
          id="el9q8hpllgb9"
          className="animable"
        />
        <path
          d="M427,179.59a12.86,12.86,0,0,0,1.54-2.41,12.32,12.32,0,0,0,.79-7.6,15.8,15.8,0,0,0-1.93-5,26.74,26.74,0,0,0-3.78-4.86c-3-3.18-7-6-10.57-9.58a20.49,20.49,0,0,1-4.36-6,23.19,23.19,0,0,1-1.87-6.67,58.44,58.44,0,0,1,0-11.68c.25-3.31.51-6,.68-7.83.09-.89.15-1.59.2-2.13a4.63,4.63,0,0,1,.11-.74,3.57,3.57,0,0,1,0,.75c0,.54-.06,1.25-.11,2.13-.12,1.91-.3,4.58-.52,7.84a60.83,60.83,0,0,0,.16,11.6,23.09,23.09,0,0,0,1.85,6.52,20.32,20.32,0,0,0,4.27,5.88c3.56,3.55,7.52,6.37,10.55,9.6a26.5,26.5,0,0,1,3.8,5,16,16,0,0,1,1.93,5.12,12.33,12.33,0,0,1-1,7.75,9.25,9.25,0,0,1-1.19,1.79A5,5,0,0,1,427,179.59Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '418.2495470046997px 147.33999252319336px',
          }}
          id="elcxt3sv6xeo5"
          className="animable"
        />
        <path
          d="M434.68,425.1l4.74,23.24,9.05,17.3A2.43,2.43,0,0,1,447.3,469h0a2.45,2.45,0,0,1-2.22-.14c-4.3-2.58-20.07-12.15-20.32-13.87-.3-2-6.63-24.18-6.63-24.18Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '433.4408235549927px 447.1506690979004px',
          }}
          id="elw8axgvvcfig"
          className="animable"
        />
        <g id="el4k3qs2v6aqf">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '435.84999084472656px 461.3395700454712px',
            }}
            className="animable"
          >
            <path
              d="M447.3,469l-22.9-15.57.22,1a3.67,3.67,0,0,0,1.38,2.12c1.86,1.39,7.08,5.12,19,12.35a2.44,2.44,0,0,0,2.29.12Z"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '435.84999084472656px 461.3395700454712px',
              }}
              id="elneerbe0tdfg"
              className="animable"
            />
          </g>
        </g>
        <g id="elq98niw0a9zs">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '426.95227003097534px 446.18345963954926px',
            }}
            className="animable"
          >
            <path
              d="M427.45,444.88a1.46,1.46,0,0,1,.81,1.78,1.4,1.4,0,0,1-1.76.83,1.55,1.55,0,0,1-.85-1.89,1.46,1.46,0,0,1,1.92-.66"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '426.95227003097534px 446.18345963954926px',
              }}
              id="elbhsh7wrmj3k"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M439.71,460.09a7.36,7.36,0,0,1,1.62-2.26,7.5,7.5,0,0,1,2.54-1.12c0-.06-.32-.17-.88-.12a3.83,3.83,0,0,0-3.22,2.61C439.61,459.73,439.65,460.08,439.71,460.09Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '441.7636740207672px 458.33364260196686px',
          }}
          id="eln6132zkfbdd"
          className="animable"
        />
        <path
          d="M442.06,462.81c.14.07.71-.85,1.82-1.46a22.22,22.22,0,0,1,2.2-.81,2.7,2.7,0,0,0-2.45.36C442.36,461.6,441.93,462.77,442.06,462.81Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '444.0588984489441px 461.60379207134247px',
          }}
          id="eloxu8x0tx0gh"
          className="animable"
        />
        <path
          d="M435.74,456.82a22.74,22.74,0,0,1,2.66-2.45,25.76,25.76,0,0,1,3.25-1.58,6.65,6.65,0,0,0-5.91,4Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '438.6949768066406px 454.8049774169922px',
          }}
          id="elnaxdwzudr5"
          className="animable"
        />
        <path
          d="M433.71,449.88c.09.12,1.25-.7,2.9-1.14s3.05-.34,3.07-.5a6,6,0,0,0-6,1.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '436.67999267578125px 448.9505780339241px',
          }}
          id="elm27nkw6y7pd"
          className="animable"
        />
        <path
          d="M432.14,443.09a12.47,12.47,0,0,1,3-1.26,11.54,11.54,0,0,1,3.24.07c0-.06-.29-.29-.89-.48a5.26,5.26,0,0,0-4.68.9C432.31,442.71,432.1,443.05,432.14,443.09Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '435.2576093673706px 442.15243846178055px',
          }}
          id="el4jt608rahgm"
          className="animable"
        />
        <path
          d="M434.79,440.54a2.11,2.11,0,0,0-.16-.88,6.24,6.24,0,0,0-1.22-2.13,2.73,2.73,0,0,0-1.45-1,1,1,0,0,0-1,.45,1.54,1.54,0,0,0-.13,1.13,3.44,3.44,0,0,0,3.64,2.43,4,4,0,0,0,3.35-2.9,1.38,1.38,0,0,0-.19-1.14,1,1,0,0,0-1.09-.27,3.34,3.34,0,0,0-1.34,1.14,7,7,0,0,0-1.17,2.16,2.16,2.16,0,0,0-.18.88,11.45,11.45,0,0,1,1.63-2.81,3.17,3.17,0,0,1,1.19-1,.51.51,0,0,1,.6.15.92.92,0,0,1,.08.75A3.56,3.56,0,0,1,434.4,440a3,3,0,0,1-3.12-2,1.17,1.17,0,0,1,.05-.79.52.52,0,0,1,.56-.26,2.53,2.53,0,0,1,1.25.85A8.89,8.89,0,0,1,434.79,440.54Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '434.3227984905243px 438.36291337013245px',
          }}
          id="elqtyx11ejcu"
          className="animable"
        />
        <path
          d="M371.93,427.54l1.1,18.87s-18.81,7.46-18.95,11l36.67-.82-.5-29.48Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '372.4149932861328px 442.25999450683594px',
          }}
          id="eltxrbt9kjpei"
          className="animable"
        />
        <g id="elnn9u2u9s25">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '384.0128461122513px 445.9485261440277px',
            }}
            className="animable"
          >
            <path
              d="M384.34,444.57a1.49,1.49,0,0,1,1.07,1.68,1.43,1.43,0,0,1-1.66,1.08,1.57,1.57,0,0,1-1.13-1.79,1.5,1.5,0,0,1,1.86-.93"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '384.0128461122513px 445.9485261440277px',
              }}
              id="elorefcemaowe"
              className="animable"
            />
          </g>
        </g>
        <g id="el9xi7rg9l1bg">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '372.4056167602539px 455.4550018310547px',
            }}
            className="animable"
          >
            <path
              d="M390.75,456.56l-.16-3-35.1,1.89s-1.62.75-1.41,1.9Z"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '372.4056167602539px 455.4550018310547px',
              }}
              id="el8hc8z8ghdjd"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M372.44,446.24c0,.18.9.24,1.8.79s1.38,1.3,1.54,1.23-.13-1.11-1.22-1.76S372.39,446.07,372.44,446.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '374.129597902298px 447.1634485721588px',
          }}
          id="elj2vgxeztg2b"
          className="animable"
        />
        <path
          d="M368.62,447.91c0,.18.75.47,1.37,1.21s.82,1.54,1,1.53.27-1-.52-1.94S368.62,447.74,368.62,447.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '369.8664274215698px 449.23994159698486px',
          }}
          id="el36dmd4yxm3z"
          className="animable"
        />
        <path
          d="M366.54,452.57c.17,0,.4-.87-.09-1.84s-1.32-1.34-1.4-1.19.46.66.84,1.47S366.36,452.55,366.54,452.57Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '365.8936198949814px 451.03888833522797px',
          }}
          id="el0xst6fobsdj"
          className="animable"
        />
        <path
          d="M372.66,441.91c.08.16.9-.11,1.91-.06s1.81.35,1.9.19-.68-.78-1.88-.81S372.57,441.77,372.66,441.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '374.56519174575806px 441.6577143073082px',
          }}
          id="el2520kj5yihi"
          className="animable"
        />
        <g id="ely8yj3nekah">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '381.26499938964844px 432.8400115966797px',
            }}
            className="animable"
          >
            <polygon
              points="372.16 431.27 372.35 434.64 390.37 434.07 390.32 431.04 372.16 431.27"
              id="ellomg8xa5lt"
              style={{
                transformOrigin: '381.26499938964844px 432.8400115966797px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M372.51,438.1a3.5,3.5,0,0,0,1.84-.05,8.07,8.07,0,0,0,1.91-.64,8.41,8.41,0,0,0,1-.58,2.49,2.49,0,0,0,.54-.44.78.78,0,0,0,.06-1,1,1,0,0,0-.79-.39,2.69,2.69,0,0,0-.69.11,6.59,6.59,0,0,0-1.13.42,6.51,6.51,0,0,0-1.67,1.15c-.83.8-1.11,1.48-1.05,1.51s.49-.51,1.34-1.18a7.37,7.37,0,0,1,1.62-1,6.35,6.35,0,0,1,1-.35c.39-.11.72-.12.82.05s.05.09,0,.21a2.06,2.06,0,0,1-.4.32,9.8,9.8,0,0,1-1,.58,10.4,10.4,0,0,1-1.76.72A11,11,0,0,0,372.51,438.1Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '375.2615909576416px 436.59971475601196px',
          }}
          id="elwh47iypn2v"
          className="animable"
        />
        <path
          d="M372.75,438.35a3,3,0,0,0,.44-1.79,5.82,5.82,0,0,0-.29-2,6,6,0,0,0-.49-1.11,1.56,1.56,0,0,0-1.2-.9.87.87,0,0,0-.75.53,2.46,2.46,0,0,0-.18.68,4.24,4.24,0,0,0,.86,3.12c.74.93,1.49,1.13,1.5,1.07s-.57-.43-1.14-1.33a4.12,4.12,0,0,1-.62-1.71,3.77,3.77,0,0,1,0-1.06c.05-.39.19-.71.33-.67s.5.27.66.58a7.48,7.48,0,0,1,.48,1,6.49,6.49,0,0,1,.39,1.82C372.83,437.65,372.65,438.32,372.75,438.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '371.7228949069977px 435.45001220703125px',
          }}
          id="el4vsy3gq52o2"
          className="animable"
        />
        <path
          d="M400.44,225.59s10.78,23.41,12.41,30.24,31.73,187.29,31.73,187.29l-27.66,1.68L379.36,268.26l15.11,175.26-27.21,2.27s-20.57-185.2-19.7-190.42c1.32-7.89,8-30.59,8-30.59Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '396.0565872192383px 335.2850112915039px',
          }}
          id="elmfc4gfjhjg"
          className="animable"
        />
        <path
          d="M379.14,267.13s0,.15-.23.3a1,1,0,0,1-1.06-.1,2.38,2.38,0,0,1-.65-1.56l-.36-2.15c-.53-3.19-1.22-7.61-1.94-12.48s-1.37-9.3-1.8-12.5c-.19-1.53-.35-2.81-.48-3.8a7.3,7.3,0,0,1-.11-1.4,7,7,0,0,1,.31,1.37c.17,1,.38,2.25.64,3.77.53,3.19,1.22,7.6,2,12.48s1.36,9.3,1.79,12.5c.1.79.2,1.51.28,2.16a2.31,2.31,0,0,0,.5,1.45.85.85,0,0,0,.89.17C379.07,267.24,379.11,267.11,379.14,267.13Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '375.8244252204895px 250.48862266540527px',
          }}
          id="elc2udrs2k1xm"
          className="animable"
        />
        <path
          d="M376.31,237s0-.16.26-.31a1.5,1.5,0,0,1,1.09-.16,1.46,1.46,0,0,1,1.16,1.19,1.74,1.74,0,0,1-.89,1.84,1.82,1.82,0,0,1-2-.34,1.67,1.67,0,0,1-.47-1.59c.24-1,.92-1.18.91-1.12a2.81,2.81,0,0,0-.55,1.18,1.31,1.31,0,0,0,.43,1.18,1.38,1.38,0,0,0,1.46.23,1.3,1.3,0,0,0,.65-1.3,1.11,1.11,0,0,0-.78-.92A1.89,1.89,0,0,0,376.31,237Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '377.1312668323517px 238.10533487796783px',
          }}
          id="elyow5v9erfhc"
          className="animable"
        />
        <path
          d="M328.69,122.19,311.74,96h0l-5.16-8.62s-1.53-8.64-2.26-11.07c-1.52-5-2-4.87-2.52-4.59-1.48.74,2.33,8.9.49,7.62s-3.5-10.52-5-9.69c-2,1.1,2.17,9.56,2.47,10.31s-.77,1.19-1,.51c-.34-1-4.11-11.24-6.07-10.18-1.08.58.15,2.43.15,2.43s4.24,9.33,3.3,9.8-3.63-4.93-4.4-6.81-2-2.25-2.5-1.23c-.37.7,1.86,6.52,2.67,8.37s3.11,6.86,0,5.31-6.15-1.55-7-1a1.1,1.1,0,0,0,.77,1.93,12.88,12.88,0,0,1,3.41.93,8.26,8.26,0,0,1,2.44,1.45c.85.72,1.53,1.37,2.1,1.93l4.21,8.75h0l18.59,36.49,38.93,32.24,9.82-17.7Z"
          style={{
            fill: 'rgb(147, 103, 84)',
            transformOrigin: '324.85523986816406px 120.23868179321289px',
          }}
          id="eleyxy3tbhsur"
          className="animable"
        />
        <path
          d="M429.24,268.37c.24.77.5,1.67.75,2.75a8.22,8.22,0,0,1,.17,2.84,12.86,12.86,0,0,1-.73,3.46c-.48,1,.49,2,1.36,1.56s2.25-3.14,2.31-6.65,3.47.84,4.74,2.41,5.43,6.21,6.22,6.2c1.16,0,1.35-1.26.05-2.79s-4.89-6.4-4-7,7.19,7.42,7.19,7.42,1.08,1.94,2.1,1.25c1.83-1.26-5.55-9.31-6.28-10.06-.5-.52.41-1.24.92-.65s6.15,8.17,8,6.91c1.44-1-6-6.68-6.31-8.9s5.21,4.91,6.55,3.93c.49-.37.82-.71-2.94-4.34-1.82-1.77-8.8-7.09-8.8-7.09L425.75,211l-18.36.3Z"
          style={{
            fill: 'rgb(147, 103, 84)',
            transformOrigin: '429.9812831878662px 245.97000885009766px',
          }}
          id="elwe0jkjakys"
          className="animable"
        />
        <path
          d="M372.44,153.15h0a90.31,90.31,0,0,1-8.76-3.91l-29.12-22.06-13,17.36s33.23,30,33.78,29.84S372.44,153.15,372.44,153.15Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '347px 150.78030967712402px',
          }}
          id="elmhispwbmach"
          className="animable"
        />
        <path
          d="M374.64,153.08l-2.2.07a15.22,15.22,0,0,0-13.93,10.41c-2.22,6.68-2.09,8.86-3.63,13.85-3.68,11.92,2.93,26.39,2.93,26.39l-2.28,21,44.91.81,2.26-25.28,8.39-37.85s-1.86-8.12-9-8.78C398.39,153.34,374.64,153.08,374.64,153.08Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '382.427640914917px 189.34500885009766px',
          }}
          id="elu0ddrswj98e"
          className="animable"
        />
        <path
          d="M403.41,154.34s10.64-.05,13.88,12.22S427,211.1,427,211.1l-20.16,6.06L396,172.87a21.88,21.88,0,0,1-.87-7.75C395.46,160.69,397.12,154.94,403.41,154.34Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '411.04015731811523px 185.75000190734863px',
          }}
          id="el41eujkkotg1"
          className="animable"
        />
        <polygon
          points="371.45 153.68 375 146.89 381 150.29 381 153.24 382.9 150.29 397.05 146.89 397.05 155.28 380.53 157.08 371.45 153.68"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '384.25px 151.98500061035156px',
          }}
          id="ellc85od3vvcf"
          className="animable"
        />
        <path
          d="M360.37,164a10,10,0,0,1-.75,1.44c-.26.45-.57,1-.88,1.67s-.72,1.4-1.06,2.27-.76,1.79-1.09,2.83-.68,2.15-1,3.32a42.13,42.13,0,0,0-1,15.81c.18,1.21.32,2.37.58,3.43a30.18,30.18,0,0,0,.72,2.94c.22.91.53,1.69.76,2.39a16.64,16.64,0,0,0,.66,1.77,10.59,10.59,0,0,1,.55,1.53,10.91,10.91,0,0,1-.74-1.45,16.62,16.62,0,0,1-.75-1.75c-.25-.7-.59-1.48-.83-2.38a29.12,29.12,0,0,1-.8-3c-.27-1.07-.43-2.23-.63-3.46a43.74,43.74,0,0,1-.28-8,44.27,44.27,0,0,1,1.31-7.95c.35-1.19.66-2.32,1.07-3.35a28.51,28.51,0,0,1,1.17-2.83,24.7,24.7,0,0,1,1.13-2.25,16.51,16.51,0,0,1,1-1.65A8.8,8.8,0,0,1,360.37,164Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '357.06492710113525px 183.69998931884766px',
          }}
          id="elprigl1ula1"
          className="animable"
        />
        <path
          d="M379.94,149.76a8.58,8.58,0,0,1-.53,2.05c-.39,1.25-1,3-1.62,4.84-.11.29-.21.58-.31.86l-.11.3-.27-.16a20.17,20.17,0,0,1-3.58-2.75,5.53,5.53,0,0,1-1.18-1.4,50.25,50.25,0,0,0,5,3.7l-.38.14.31-.87c.66-1.88,1.29-3.57,1.76-4.78A8.14,8.14,0,0,1,379.94,149.76Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '376.13999938964844px 153.78499603271484px',
          }}
          id="el605dugc813l"
          className="animable"
        />
        <path
          d="M391.56,156a10.84,10.84,0,0,1-2.14.91c-1.34.51-3.2,1.17-5.29,1.88l-.3.11,0-.31,0-.26c-.33-2.24-.59-4.27-.76-5.74a11.22,11.22,0,0,1-.17-2.4,11.09,11.09,0,0,1,.53,2.35c.26,1.45.59,3.48.92,5.71l0,.26-.34-.21c2.09-.7,4-1.31,5.35-1.73A9.76,9.76,0,0,1,391.56,156Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '387.2261891365051px 154.54501342773438px',
          }}
          id="elietu4szokv"
          className="animable"
        />
        <path
          d="M399,216.63a7.24,7.24,0,0,1,1.31,7.94,18.23,18.23,0,0,0,0-4.08A19.32,19.32,0,0,0,399,216.63Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '399.97824347019196px 220.5999984741211px',
          }}
          id="eld03hf0l01rq"
          className="animable"
        />
        <path
          d="M425.29,204a15,15,0,0,1-2.88.88c-1.8.47-4.3,1-7.09,1.57s-5.34.89-7.18,1.11a16.51,16.51,0,0,1-3,.22,18.21,18.21,0,0,1,3-.59c1.82-.31,4.35-.73,7.13-1.25s5.29-1,7.11-1.41A18.7,18.7,0,0,1,425.29,204Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '415.2149963378906px 205.89134621620178px',
          }}
          id="elmfu395jwdo"
          className="animable"
        />
        <path
          d="M423,191.72a15.67,15.67,0,0,1-3,1.1c-1.86.58-4.46,1.28-7.34,2s-5.49,1.35-7.37,1.84a24.29,24.29,0,0,1-3.06.74,15.8,15.8,0,0,1,3-1.09c1.86-.59,4.46-1.29,7.34-2s5.49-1.34,7.37-1.84A24.29,24.29,0,0,1,423,191.72Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '412.6150207519531px 194.56000518798828px',
          }}
          id="elcysb8rru0p"
          className="animable"
        />
        <path
          d="M406.82,217.16a6.38,6.38,0,0,1-.37-1.17c-.21-.86-.49-1.94-.81-3.23-.66-2.73-1.54-6.51-2.49-10.69s-1.76-8-2.34-10.73c-.26-1.29-.47-2.38-.65-3.26a6.25,6.25,0,0,1-.17-1.21,4.68,4.68,0,0,1,.37,1.16l.81,3.23c.67,2.73,1.55,6.51,2.49,10.7s1.77,8,2.34,10.72c.26,1.3.48,2.39.65,3.27A4.68,4.68,0,0,1,406.82,217.16Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '403.4049987792969px 202.01499938964844px',
          }}
          id="elfd7uopi0e4"
          className="animable"
        />
        <path
          d="M421.92,182.3c0,.14-15.07-.15-33.65-.65s-33.64-1-33.64-1.16,15.07.14,33.65.64S421.92,182.15,421.92,182.3Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '388.27500915527344px 181.3910015821457px',
          }}
          id="elisgo40ys5ui"
          className="animable"
        />
        <path
          d="M416.76,165.17a2.17,2.17,0,0,1-.58.09l-1.67.14c-1.46.12-3.56.26-6.17.42-5.21.31-12.41.65-20.37.87s-15.17.26-20.38.23c-2.61,0-4.72,0-6.18-.08l-1.68-.06a3.86,3.86,0,0,1-.59-.05,2.08,2.08,0,0,1,.59,0l1.68-.05,6.17-.08c5.22-.06,12.42-.17,20.38-.38s15.15-.5,20.36-.72l6.18-.25,1.68,0A2.59,2.59,0,0,1,416.76,165.17Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '387.95001220703125px 166.0493741631508px',
          }}
          id="elvo13w7uw58m"
          className="animable"
        />
        <path
          d="M344.75,165.94c-.11-.1,3.33-4.24,7.67-9.25s8-9,8.07-8.91-3.33,4.23-7.67,9.25S344.86,166,344.75,165.94Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '352.61926078796387px 156.85958862304688px',
          }}
          id="elpnbey1d8fa"
          className="animable"
        />
        <path
          d="M401.15,201c0,.15-10.28-.76-22.93-2s-22.9-2.4-22.89-2.55,10.28.77,22.94,2S401.16,200.9,401.15,201Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '378.2400131225586px 198.7250621318817px',
          }}
          id="elknhwo3vp2ia"
          className="animable"
        />
        <path
          d="M401.66,214.88c0,.15-10,0-22.26-.24s-22.25-.62-22.25-.76,10,0,22.26.24S401.66,214.74,401.66,214.88Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '379.4049987792969px 214.382166326046px',
          }}
          id="elzz0ec3h86uk"
          className="animable"
        />
        <path
          d="M371.45,224.64a3.81,3.81,0,0,1,0-.74c0-.48,0-1.2,0-2.11,0-1.84.14-4.5.36-7.78.11-1.64.25-3.43.45-5.35s.49-4,.76-6.12c.54-4.31,1-9.06,1.5-14a205,205,0,0,1,3.65-25.41c.73-3.2,1.48-5.76,2-7.51.28-.83.51-1.5.69-2a3.39,3.39,0,0,1,.27-.69,3.46,3.46,0,0,1-.17.72c-.16.51-.35,1.19-.6,2-.5,1.76-1.19,4.33-1.87,7.53A230.36,230.36,0,0,0,375,188.55c-.5,5-1,9.74-1.54,14-.29,2.15-.59,4.19-.81,6.1s-.38,3.71-.52,5.34c-.26,3.27-.41,5.92-.51,7.75l-.12,2.11A3.86,3.86,0,0,1,371.45,224.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '376.28100395202637px 188.78500366210938px',
          }}
          id="elx5otthhma7"
          className="animable"
        />
        <rect
          x="387.68"
          y="180.48"
          width="10.88"
          height="2.83"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '393.12px 181.89499999999998px',
          }}
          id="elw80q8id356c"
          className="animable"
        />
        <g id="ellzhjvnze17r">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '399.9481956958771px 201.51998901367188px',
            }}
            className="animable"
          >
            <path
              d="M400.3,189.09a22.08,22.08,0,0,0,.76,24.86q1-7,2-14"
              id="elypx8jf6oud"
              style={{
                transformOrigin: '399.9481956958771px 201.51998901367188px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M394,119.23c1.28,2.63.65,5.78-.28,8.56s-2.12,5.59-1.88,8.51c.22,2.71,1.68,5.2,1.94,7.91.45,4.56-2.47,8.7-3.67,13.13A18.09,18.09,0,0,0,394,173.83a2.16,2.16,0,0,0,1.51.89,1.61,1.61,0,0,0,1.37-1.36,7.19,7.19,0,0,0-.05-2.07c-.55-6.54,5.74-11.78,6.65-18.28.6-4.23-1.15-8.41-1.41-12.67-.33-5.36,1.69-10.56,2.35-15.89a12.37,12.37,0,0,0-.31-5.45,5.68,5.68,0,0,0-3.68-3.79,3.74,3.74,0,0,0-4.47,2.21"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '397.0554795265198px 144.89666938781738px',
          }}
          id="ell2qrebfzqp"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-3--inject-211"
        style={{ transformOrigin: '321.88255310058594px 275.4895782470703px' }}
        className="animable"
      >
        <path
          d="M272.91,159.29l-21.17,13.4,15-41.05,4.05-8.09c.54-.68,1.2-1.46,2-2.35a9,9,0,0,1,2.45-1.87,13.43,13.43,0,0,1,3.56-1.44,1.19,1.19,0,0,0,.57-2.18c-.95-.5-4.18-.11-7.37,2s-1.36-3.63-.72-5.72,2.29-8.64,1.8-9.35c-.72-1-1.95-.45-2.54,1.65s-2.78,8.28-3.86,7.89,2.29-11,2.29-11,1.09-2.15-.15-2.64c-2.24-.88-5,10.64-5.23,11.74-.16.77-1.36.39-1.14-.42s3.61-10.49,1.34-11.41c-1.75-.71-2.36,9.46-4.17,11.07s1.25-7.66-.45-8.27c-.63-.23-1.13-.31-2.11,5.27-.48,2.71-1,12.21-1,12.21l-4.93,9.72.12.11-20.18,42.62c-3.87,10.22,2.45,18.48,8.78,22.22h0a17.85,17.85,0,0,0,19-.54l24.45-16.33Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '256.5927848815918px 147.1455192565918px',
          }}
          id="el3wesoi27hp7"
          className="animable"
        />
        <path
          d="M386.72,249.22c.51.75,1.07,1.65,1.69,2.73a9.18,9.18,0,0,1,1.07,3,14.44,14.44,0,0,1,.3,4,1.24,1.24,0,0,0,2,1.26c.8-.78,1.43-4.1.4-7.91s4-.19,5.87,1.1,7.82,5,8.67,4.74c1.24-.38,1.07-1.79-.83-3s-7.29-5.36-6.57-6.31,10.12,5.74,10.12,5.74,1.77,1.75,2.65.68c1.58-1.93-8.93-8.3-9.94-8.88-.71-.4,0-1.46.78-1s9.21,6.88,10.84,4.93c1.25-1.5-8.59-5.32-9.61-7.62s7.17,3.66,8.31,2.18c.42-.55.66-1-4.54-3.76-2.52-1.34-11.74-4.88-11.74-4.88l-56.55-73L323.24,178Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '368.559757232666px 211.86131286621094px',
          }}
          id="elbmb8tmalhhs"
          className="animable"
        />
        <path
          d="M286.09,427.81l1.08,18.52s-18.47,7.32-18.6,10.76l36-.18-.51-29.55Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '286.5699768066406px 442.2250061035156px',
          }}
          id="el9u2ycx1jrkp"
          className="animable"
        />
        <g id="el2s4kk8zqtfw">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '297.9461895227432px 445.88275277614594px',
            }}
            className="animable"
          >
            <path
              d="M298.26,444.52a1.49,1.49,0,0,1,1.06,1.66,1.42,1.42,0,0,1-1.64,1.06,1.54,1.54,0,0,1-1.1-1.76,1.46,1.46,0,0,1,1.82-.91"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '297.9461895227432px 445.88275277614594px',
              }}
              id="el2szqjdk72ty"
              className="animable"
            />
          </g>
        </g>
        <g id="elcq2nqljcpc">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '286.58545112609863px 455.5px',
            }}
            className="animable"
          >
            <path
              d="M304.57,456.91l0-3L270,455.24s-1.59.73-1.38,1.85Z"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '286.58545112609863px 455.5px',
              }}
              id="elk0uo1zmrhj"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M286.58,446.16c0,.18.89.24,1.77.78s1.35,1.28,1.51,1.2-.12-1.08-1.2-1.72S286.54,446,286.58,446.16Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '288.24025762081146px 447.0678962469101px',
          }}
          id="elpnoaa3b85qe"
          className="animable"
        />
        <path
          d="M282.84,447.81c0,.17.73.45,1.35,1.18s.8,1.51,1,1.5.27-1-.51-1.9S282.84,447.64,282.84,447.81Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '284.0810955762863px 449.1114169359207px',
          }}
          id="elzeifswvgkm"
          className="animable"
        />
        <path
          d="M280.8,452.37c.16,0,.38-.85-.09-1.8s-1.3-1.32-1.37-1.17.45.65.82,1.44S280.62,452.36,280.8,452.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '280.1636173129082px 450.8688726425171px',
          }}
          id="elql1r898u8k"
          className="animable"
        />
        <path
          d="M286.8,441.91c.08.16.88-.1,1.88-.05s1.77.34,1.86.19-.67-.77-1.84-.8S286.71,441.78,286.8,441.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '288.6702173948288px 441.670766800642px',
          }}
          id="elovd3fke979n"
          className="animable"
        />
        <path
          d="M286.65,438.17a3.27,3.27,0,0,0,1.81-.05,7.7,7.7,0,0,0,1.87-.62,8.7,8.7,0,0,0,1-.57,2,2,0,0,0,.54-.44.76.76,0,0,0,.06-.93,1,1,0,0,0-.78-.39,2.61,2.61,0,0,0-.68.11,6.9,6.9,0,0,0-1.11.41,6.53,6.53,0,0,0-1.64,1.13c-.81.79-1.08,1.45-1,1.49s.47-.51,1.31-1.16a7.25,7.25,0,0,1,1.58-.95,7.77,7.77,0,0,1,1-.34c.38-.11.71-.12.81.05s0,.09,0,.2a1.67,1.67,0,0,1-.39.32,10.72,10.72,0,0,1-.94.57,10,10,0,0,1-1.73.7A14,14,0,0,0,286.65,438.17Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '289.3554081916809px 436.74103116989136px',
          }}
          id="eltj852buu5q"
          className="animable"
        />
        <path
          d="M286.89,438.42a2.87,2.87,0,0,0,.44-1.75,6.14,6.14,0,0,0-.29-2,5.73,5.73,0,0,0-.49-1.08,1.52,1.52,0,0,0-1.17-.89.86.86,0,0,0-.74.52,2.75,2.75,0,0,0-.17.67,3.75,3.75,0,0,0,0,1.21,4.15,4.15,0,0,0,.81,1.85c.72.91,1.46,1.11,1.47,1s-.56-.42-1.12-1.3a4.39,4.39,0,0,1-.61-1.68,4.11,4.11,0,0,1,0-1.05c.05-.38.19-.69.33-.66s.49.28.65.58a6.08,6.08,0,0,1,.46,1,6.17,6.17,0,0,1,.39,1.79C287,437.73,286.79,438.4,286.89,438.42Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '285.87932205200195px 435.55999755859375px',
          }}
          id="ell3jghyx7kr"
          className="animable"
        />
        <path
          d="M348.38,427.54l1.41,18.5s-18.33,7.65-18.4,11.09l36-1.44-2.9-28.84Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '349.3900146484375px 441.99000549316406px',
          }}
          id="elb6r6odkasr"
          className="animable"
        />
        <g id="el2jyrd98krdq">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '360.5530607700348px 445.35955464839935px',
            }}
            className="animable"
          >
            <path
              d="M360.85,444a1.47,1.47,0,0,1,1.08,1.63,1.41,1.41,0,0,1-1.61,1.09,1.55,1.55,0,0,1-1.14-1.74,1.46,1.46,0,0,1,1.8-.94"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '360.5530607700348px 445.35955464839935px',
              }}
              id="el5utweu356t"
              className="animable"
            />
          </g>
        </g>
        <g id="elleajzxqsptg">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '349.36348152160645px 454.9499969482422px',
            }}
            className="animable"
          >
            <path
              d="M367.36,455.69l-.22-2.92-34.41,2.48s-1.57.76-1.34,1.88Z"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '349.36348152160645px 454.9499969482422px',
              }}
              id="elmoxfbs8jkv"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M349.2,445.88c0,.18.89.22,1.78.75s1.38,1.25,1.54,1.18-.15-1.08-1.23-1.71S349.15,445.72,349.2,445.88Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '350.8788994550705px 446.75418055057526px',
          }}
          id="el3kgbi8sm4b5"
          className="animable"
        />
        <path
          d="M345.49,447.6c0,.17.74.43,1.36,1.15s.83,1.5,1,1.49.25-1-.55-1.89S345.49,447.43,345.49,447.6Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '346.7258689403534px 448.8793671131134px',
          }}
          id="elkw0dmbdissp"
          className="animable"
        />
        <path
          d="M343.53,452.2c.16,0,.37-.86-.12-1.8s-1.33-1.3-1.4-1.15.46.65.85,1.43S343.35,452.19,343.53,452.2Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '342.8593029975891px 450.7085876464844px',
          }}
          id="elffy59ss6ovf"
          className="animable"
        />
        <path
          d="M349.34,441.63c.08.16.88-.12,1.88-.09s1.78.31,1.86.16-.68-.76-1.85-.77S349.25,441.5,349.34,441.63Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '351.20947539806366px 441.33691251277924px',
          }}
          id="elndo09t1vwld"
          className="animable"
        />
        <path
          d="M349.13,437.89a3.22,3.22,0,0,0,1.8-.08,8.15,8.15,0,0,0,1.86-.65,8,8,0,0,0,1-.59,2.31,2.31,0,0,0,.53-.45.76.76,0,0,0,0-.94,1,1,0,0,0-.78-.37,2.44,2.44,0,0,0-.67.12,6.92,6.92,0,0,0-1.11.43,6.43,6.43,0,0,0-1.62,1.16c-.8.81-1.06,1.47-1,1.5s.47-.51,1.29-1.18a6.85,6.85,0,0,1,2.59-1.33c.38-.11.71-.13.81,0s0,.08,0,.2a2,2,0,0,1-.39.32,9.58,9.58,0,0,1-.93.59,10.16,10.16,0,0,1-1.71.73A13.33,13.33,0,0,0,349.13,437.89Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '351.8063678741455px 436.41562283039093px',
          }}
          id="el7aygjv8ezq"
          className="animable"
        />
        <path
          d="M349.37,438.14a3,3,0,0,0,.4-1.76,6,6,0,0,0-.32-2,5.78,5.78,0,0,0-.51-1.07,1.47,1.47,0,0,0-1.18-.86.83.83,0,0,0-.73.53,2.31,2.31,0,0,0-.16.67,3.74,3.74,0,0,0,.05,1.21,4.09,4.09,0,0,0,.84,1.83c.74.9,1.48,1.08,1.49,1s-.57-.4-1.14-1.28a4.24,4.24,0,0,1-.64-1.66,3.69,3.69,0,0,1,0-1.05c0-.38.17-.7.32-.66s.49.26.65.56a6.22,6.22,0,0,1,.49,1,6.67,6.67,0,0,1,.42,1.78C349.43,437.45,349.27,438.11,349.37,438.14Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '348.3112744092941px 435.2950134277344px',
          }}
          id="el7s8yjgy9wj4"
          className="animable"
        />
        <path
          d="M318.75,114.12l-3.53,40.95-20.51-1.64c-.13-2.39,0-11.66,0-11.66s-8.53-1.32-8.63-9.85c-.06-4.15.54-12.71,1.16-20.42A15.79,15.79,0,0,1,303.94,97h0A15.78,15.78,0,0,1,318.75,114.12Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '302.4425849914551px 126.02014541625977px',
          }}
          id="elnma7ixi2pz"
          className="animable"
        />
        <path
          d="M294.74,141.65a19.82,19.82,0,0,0,11.12-3.16s-2.63,6.14-11.14,5.37Z"
          style={{
            fill: 'rgb(209, 115, 74)',
            transformOrigin: '300.28997802734375px 141.20839262008667px',
          }}
          id="elr6b2a7191m"
          className="animable"
        />
        <path
          d="M289.3,118.54c.14.16,1.1-.47,2.41-.41s2.24.78,2.39.62-.07-.36-.47-.68a3.36,3.36,0,0,0-3.83-.18C289.38,118.18,289.23,118.46,289.3,118.54Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '291.71540546417236px 118.07474958896637px',
          }}
          id="eldheyii95vjd"
          className="animable"
        />
        <path
          d="M301.3,118.72c.16.15,1.06-.56,2.37-.59s2.29.59,2.43.43-.09-.36-.52-.65a3.33,3.33,0,0,0-1.95-.54,3.22,3.22,0,0,0-1.88.67C301.36,118.36,301.23,118.65,301.3,118.72Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '303.71142292022705px 118.0541559457779px',
          }}
          id="elwtjs7hbvi9i"
          className="animable"
        />
        <path
          d="M297.23,126.65a8.35,8.35,0,0,0-2.13-.39c-.34,0-.65-.1-.71-.33a1.7,1.7,0,0,1,.22-1q.48-1.22,1-2.55a44.28,44.28,0,0,0,2.23-6.67,44.32,44.32,0,0,0-2.76,6.48c-.33.89-.64,1.74-.95,2.56a2,2,0,0,0-.17,1.31.83.83,0,0,0,.55.49,2.1,2.1,0,0,0,.57.08A9.21,9.21,0,0,0,297.23,126.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '295.8785516023636px 121.20667505264282px',
          }}
          id="elaf92c1c0qu"
          className="animable"
        />
        <path
          d="M301.09,127.55c-.22,0-.22,1.41-1.44,2.42s-2.73.86-2.74,1.06.34.27,1,.29a3.56,3.56,0,0,0,2.29-.8,3.09,3.09,0,0,0,1.11-2C301.34,127.9,301.18,127.54,301.09,127.55Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '299.11174845695496px 129.43501162528992px',
          }}
          id="elthpawhtpyj8"
          className="animable"
        />
        <path
          d="M301.65,112.65c.13.36,1.44.19,3,.38s2.78.6,3,.28c.09-.15-.13-.49-.63-.83a5,5,0,0,0-2.22-.78,4.93,4.93,0,0,0-2.32.28C301.88,112.21,301.6,112.49,301.65,112.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '304.65700340270996px 112.54665243625641px',
          }}
          id="elf23nm7jxdwf"
          className="animable"
        />
        <path
          d="M289.59,113.25c.27.35,1.3,0,2.55,0s2.31.23,2.55-.12c.11-.18-.06-.52-.52-.84a3.72,3.72,0,0,0-4.11.12C289.62,112.73,289.47,113.09,289.59,113.25Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '292.13624477386475px 112.56726455688477px',
          }}
          id="eli08o33mxarl"
          className="animable"
        />
        <path
          d="M309.49,104.77l0,0a6.7,6.7,0,0,1,2.5,4.34l0,.17c.34,2.43.27,4.91.63,7.34a11,11,0,0,0,3,6.57c.74.69,2,1.17,2.65.36a2.05,2.05,0,0,0,.31-1.12c.45-5.87,2.06-11.08,2-17.23a5.16,5.16,0,0,0-2.15-4.21c-1.28-.93-2.85-1.88-4.28-1.21s-3.28,3.36-4.39,4.49"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '315.0358052253723px 111.76437950134277px',
          }}
          id="el1vlqmitah78"
          className="animable"
        />
        <path
          d="M315.87,118c.15-.06,5.86-1.73,5.68,4.1s-6,4.45-6,4.28S315.87,118,315.87,118Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '318.5520713329315px 122.18793249130249px',
          }}
          id="eltnkl4w8fsv"
          className="animable"
        />
        <path
          d="M317.39,124.2s.1.08.27.16a1,1,0,0,0,.76,0,2.52,2.52,0,0,0,1.24-2.22,3.45,3.45,0,0,0-.24-1.46,1.17,1.17,0,0,0-.74-.8.51.51,0,0,0-.61.26c-.08.16-.05.27-.08.28s-.12-.1-.07-.34a.69.69,0,0,1,.24-.36.78.78,0,0,1,.57-.13,1.44,1.44,0,0,1,1,.94,3.37,3.37,0,0,1,.3,1.64,2.64,2.64,0,0,1-1.56,2.47,1.14,1.14,0,0,1-.93-.18C317.4,124.35,317.37,124.21,317.39,124.2Z"
          style={{
            fill: 'rgb(209, 115, 74)',
            transformOrigin: '318.71125078201294px 122.12600231170654px',
          }}
          id="elm6gwamvy8z"
          className="animable"
        />
        <path
          d="M314.45,100.73c1.43-2.34-2.5-5.69-5.38-6.59s-6.67.49-9.54,1.44c-1.8.6-3.61,1.44-5.51,1.36a13.08,13.08,0,0,1-3.7-.94,9.27,9.27,0,0,0-3.73-.74,3.54,3.54,0,0,0-3.07,1.95,2.2,2.2,0,0,0,1.48,3,2.86,2.86,0,1,0-.77,5.31c-.83-.63-2.1.41-2,1.45a3,3,0,0,0,2,2.21c2.43,1.06,5.27.72,7.79-.12s4.85-2.17,7.34-3.08,6.68-2.54,9.18-1.66c1.85.65,3.13,2.87,4.17,2.38a3.55,3.55,0,0,0,1.85-2.62,10.58,10.58,0,0,0-.11-3.32"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '297.7637577056885px 101.84595346450806px',
          }}
          id="el46ukjl87kfa"
          className="animable"
        />
        <path
          d="M284.29,100s.3.43.93,1.12a8.22,8.22,0,0,0,3.24,2.08A7.35,7.35,0,0,0,294,103c2-.89,3.68-2.67,5.64-4.35a12,12,0,0,1,6.55-3.14,6.71,6.71,0,0,1,5.58,1.93,5.06,5.06,0,0,1,1.32,3.77,3.74,3.74,0,0,1-.25,1.07c-.1.23-.17.34-.19.33a8.56,8.56,0,0,0,.22-1.41,5,5,0,0,0-1.4-3.48A6.36,6.36,0,0,0,306.27,96,11.86,11.86,0,0,0,300,99.09c-1.92,1.64-3.67,3.47-5.79,4.39a7.66,7.66,0,0,1-5.92.12,7.74,7.74,0,0,1-3.27-2.32,5.48,5.48,0,0,1-.61-.91A1.37,1.37,0,0,1,284.29,100Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '298.69601917266846px 99.79816484451294px',
          }}
          id="el8ywzm9h6v1x"
          className="animable"
        />
        <path
          d="M317.36,117.73s-.25-.16-.47-.62a3.84,3.84,0,0,1-.29-2.12c.12-1.88,1.79-3.89,2-6.49A5.86,5.86,0,0,0,318,105a4.41,4.41,0,0,0-2.17-1.87,3.72,3.72,0,0,0-1.94-.27c-.47.08-.72.19-.74.14s.2-.21.69-.36a3.72,3.72,0,0,1,2.14.1,4.77,4.77,0,0,1,2.48,2,6.2,6.2,0,0,1,.76,3.8,10.66,10.66,0,0,1-1.12,3.68,11,11,0,0,0-1.05,2.82A4.42,4.42,0,0,0,317.36,117.73Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '316.20685839653015px 110.1292929649353px',
          }}
          id="elf2g7p27lstm"
          className="animable"
        />
        <polygon
          points="334.95 246.34 368.47 441.36 342.04 444.58 304.51 270.61 307.64 442.07 282.33 442.07 272.32 244.63 334.95 246.34"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '320.39500427246094px 344.60499572753906px',
          }}
          id="el5d4ciepp7o7"
          className="animable"
        />
        <path
          d="M274.8,184.27l-9.45,5.87-10.72-20.6c4.71-3.4,19.81-13.12,23.64-15.62a18.42,18.42,0,0,1,3-1.63,30.74,30.74,0,0,1,7.94-1.94c2.42-.33,4.26-.49,5.45-.64a35.08,35.08,0,0,0,21.17,0h0c.83,0,1.64.1,2.42.19h0c7,1,13.79,5.91,18,10.47l16.68,15-16.36,19.56-5.06-6,1.19,27.63,4.83,34.36H272.18s-.14-8.1.45-19.36c.84-15.84,1.67-40.47,1.67-40.47"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '303.7799835205078px 200.31499481201172px',
          }}
          id="el51mz5iru5js"
          className="animable"
        />
        <path
          d="M274.16,201.64a32.56,32.56,0,0,0,.42-4.55c.19-2.8.44-6.68.79-11s.74-8.14,1-10.94a30.69,30.69,0,0,0,.33-4.54,25.56,25.56,0,0,0-.84,4.48c-.41,2.79-.87,6.66-1.23,10.94s-.52,8.18-.58,11A26,26,0,0,0,274.16,201.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '275.3476302623749px 186.12500762939453px',
          }}
          id="el3t5ntly9nx4"
          className="animable"
        />
        <path
          d="M330.32,174.38a13,13,0,0,0-.16,3.13c0,1.93.12,4.6.33,7.54s.51,5.59.79,7.5a11.58,11.58,0,0,0,.63,3.07,15.43,15.43,0,0,0-.12-3.12c-.17-2.21-.36-4.73-.57-7.51s-.38-5.3-.55-7.5A14,14,0,0,0,330.32,174.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '331.0344538092613px 185.00000762939453px',
          }}
          id="elk6h4ompvo9l"
          className="animable"
        />
        <rect
          x="314.03"
          y="177.65"
          width="10.88"
          height="2.83"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '319.46999999999997px 179.065px',
          }}
          id="el8tk4i3bokfq"
          className="animable"
        />
        <path
          d="M335.16,159.59a9.07,9.07,0,0,0-2.6-.37,12.36,12.36,0,0,0-6.65,2.43c-1.27.84-2.57,1.89-4,2.95a28,28,0,0,1-5,2.89,29.17,29.17,0,0,1-6.13,1.84,29.87,29.87,0,0,1-6.86.36,27.53,27.53,0,0,1-6.75-1.26,29.31,29.31,0,0,1-3.06-1.16,25.85,25.85,0,0,1-2.76-1.48c-3.55-2.09-5.91-5-8.4-6.72a10.15,10.15,0,0,0-6.66-2.18,8.14,8.14,0,0,0-2.53.71l.15-.1a3,3,0,0,1,.45-.26,5.72,5.72,0,0,1,1.91-.55,10.19,10.19,0,0,1,6.89,2.07c2.57,1.74,4.95,4.61,8.43,6.62a25.17,25.17,0,0,0,2.73,1.44,29.72,29.72,0,0,0,3,1.12,27.4,27.4,0,0,0,6.63,1.23,29.92,29.92,0,0,0,6.73-.34,29.39,29.39,0,0,0,6-1.78,27.62,27.62,0,0,0,4.95-2.8c1.46-1,2.78-2.08,4.08-2.91a12.26,12.26,0,0,1,6.85-2.32,6.59,6.59,0,0,1,2,.3,3.63,3.63,0,0,1,.48.18C335.11,159.55,335.16,159.58,335.16,159.59Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '304.4600067138672px 163.207350730896px',
          }}
          id="ellaex0i9o1re"
          className="animable"
        />
        <path
          d="M274.9,180.62c-.08,0-.72-.86-2-2a16.43,16.43,0,0,0-2.49-1.83,18.06,18.06,0,0,0-3.46-1.54,18.26,18.26,0,0,0-3.71-.73,16.44,16.44,0,0,0-3.1.05c-1.75.21-2.8.59-2.83.49s.24-.15.71-.32a10.47,10.47,0,0,1,2.07-.53,15,15,0,0,1,3.18-.17,17.5,17.5,0,0,1,3.84.71,17,17,0,0,1,3.54,1.63,14.44,14.44,0,0,1,2.51,2,9.18,9.18,0,0,1,.82.9,5.08,5.08,0,0,1,.57.73C274.79,180.36,274.93,180.59,274.9,180.62Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '266.1058940887451px 177.31950736045837px',
          }}
          id="eltphn1u3pk1f"
          className="animable"
        />
        <path
          d="M330.1,190.25a2.49,2.49,0,0,1-.5.3l-1.49.78-1.09.56c-.41.19-.86.36-1.34.57-1,.39-2,.89-3.29,1.28l-2,.65c-.68.22-1.41.38-2.15.59-1.48.43-3.11.7-4.82,1a62,62,0,0,1-11.25.69A61.31,61.31,0,0,1,291,195.11c-1.68-.46-3.28-.87-4.72-1.42-.73-.26-1.44-.47-2.1-.75l-1.9-.81c-1.22-.48-2.25-1.07-3.18-1.54-.46-.24-.9-.45-1.28-.67l-1-.64-1.43-.9a2.23,2.23,0,0,1-.48-.35,3.32,3.32,0,0,1,.54.26l1.47.81,1.06.6c.39.21.83.4,1.29.63.94.44,2,1,3.2,1.46l1.89.78c.66.26,1.37.46,2.1.72,1.44.52,3,.91,4.69,1.35a57.06,57.06,0,0,0,22.24.89c1.69-.31,3.31-.56,4.78-1,.74-.2,1.47-.34,2.15-.55l1.95-.62c1.25-.36,2.33-.84,3.3-1.2.48-.19.94-.35,1.35-.53l1.1-.51,1.53-.69A1.9,1.9,0,0,1,330.1,190.25Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '302.5050048828125px 192.3637375831604px',
          }}
          id="elcxxomm0p75"
          className="animable"
        />
        <path
          d="M348,173.42a22.11,22.11,0,0,0-3.05-.25,15,15,0,0,0-6.95,2.09,32.91,32.91,0,0,0-5.83,4.52,20.62,20.62,0,0,1-2.31,2.05,15.92,15.92,0,0,1,2.05-2.31,27.64,27.64,0,0,1,5.83-4.71,14.09,14.09,0,0,1,7.21-2,8.92,8.92,0,0,1,2.26.31A2.29,2.29,0,0,1,348,173.42Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '338.9300079345703px 177.31999969482422px',
          }}
          id="elrjnmm46a7ub"
          className="animable"
        />
        <path
          d="M331.42,211.32a2.94,2.94,0,0,1-.54.27l-1.58.71c-.68.31-1.53.67-2.54,1s-2.13.81-3.42,1.18l-2,.61c-.71.21-1.45.36-2.22.56-1.53.41-3.19.7-4.94,1a71.82,71.82,0,0,1-23,.2c-1.75-.31-3.42-.57-5-1-.77-.19-1.52-.33-2.22-.53l-2-.58c-1.3-.34-2.44-.78-3.45-1.12s-1.87-.68-2.56-1l-1.59-.67a3.48,3.48,0,0,1-.54-.27,2.21,2.21,0,0,1,.58.17l1.63.59c.7.26,1.55.58,2.57.89s2.16.72,3.46,1l2,.54c.71.18,1.46.32,2.22.49,1.53.37,3.2.61,4.94.9a74.45,74.45,0,0,0,22.89-.19c1.74-.32,3.4-.59,4.92-1,.76-.19,1.51-.33,2.21-.53l2-.58c1.29-.34,2.43-.77,3.44-1.1s1.86-.65,2.56-.93l1.61-.61A2.06,2.06,0,0,1,331.42,211.32Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '302.62001037597656px 214.48982667922974px',
          }}
          id="elsa7bs2tgkw"
          className="animable"
        />
        <path
          d="M335.18,237.56a2.38,2.38,0,0,1-.64,0l-1.8-.23c-1.56-.22-3.83-.49-6.64-.78s-6.16-.55-9.88-.74-7.83-.24-12.13-.15-8.4.36-12.11.69-7.05.75-9.84,1.17-5.05.79-6.6,1.08l-1.79.3a3.68,3.68,0,0,1-.63.08,2.41,2.41,0,0,1,.61-.18l1.77-.4c1.54-.35,3.79-.78,6.58-1.24s6.13-.91,9.85-1.29,7.83-.63,12.15-.73,8.43,0,12.16.19,7.09.51,9.9.86,5.07.66,6.63.94l1.79.33A4.65,4.65,0,0,1,335.18,237.56Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '304.1499786376953px 237.04030990600586px',
          }}
          id="elcsp33ysr0sv"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-1--inject-211"
        style={{ transformOrigin: '141.58868789672852px 276.36729431152344px' }}
        className="animable"
      >
        <path
          d="M105.41,100.83A18.9,18.9,0,0,0,86.89,116c-.77,4.44.07,9.27-2,13.28-2.71,5.32-9.82,7.77-11.41,13.53-1.34,4.81,1.82,10,.47,14.83-1,3.48-4.09,5.93-5.61,9.2a10.47,10.47,0,0,0,.69,10,9.5,9.5,0,0,0,9,4.13c2.19-.32,4.17-1.43,6.28-2.12,4.55-1.49,9.49-1,14.23-.29s9.61,1.43,14.27.33,9.13-4.55,9.83-9.29c.45-3.07-.71-6.12-1.66-9.08-6.21-19.55-3.34-40.88-7.75-60.91"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '95.06282997131348px 140.3231430053711px',
          }}
          id="el2veoqto2ve5"
          className="animable"
        />
        <path
          d="M88.05,118.84a20.41,20.41,0,0,0-4.17-4.08,7.82,7.82,0,0,0-5.53-1.44A4.93,4.93,0,0,0,74.26,117a3.61,3.61,0,0,0,3,4.22,2.83,2.83,0,0,0-3.77,2.13,3.9,3.9,0,0,0,2.38,4,6.38,6.38,0,0,0,4.89-.13A18.56,18.56,0,0,0,85,124.57l4.54-3.43"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '81.50466918945312px 120.51946258544922px',
          }}
          id="elypkai88jgr"
          className="animable"
        />
        <path
          d="M72.37,175.66a2.42,2.42,0,0,1-.78-.35,4.13,4.13,0,0,1-1.51-1.95,5.73,5.73,0,0,1-.09-3.89,12.14,12.14,0,0,1,2.81-4.34,29,29,0,0,0,4-4.72,9.13,9.13,0,0,0,.75-6.78c-.45-2.45-1.45-5-1.43-7.81a7.59,7.59,0,0,1,1.23-4.09,10.76,10.76,0,0,1,3.21-3c2.5-1.59,5.25-2.45,7.46-4A9.18,9.18,0,0,0,90.73,132,10.68,10.68,0,0,0,92,128.4a66,66,0,0,0,.46-7.11,25,25,0,0,1,1.06-6.17,13.4,13.4,0,0,1,5.19-7.3,9.06,9.06,0,0,1,2.21-1.1,5.1,5.1,0,0,1,.61-.17c.14,0,.22,0,.22,0A12.18,12.18,0,0,0,98.8,108a13.43,13.43,0,0,0-5,7.24,25.28,25.28,0,0,0-1,6.09,63.17,63.17,0,0,1-.42,7.16,10.61,10.61,0,0,1-1.3,3.72,9.5,9.5,0,0,1-2.86,3c-2.29,1.62-5.05,2.49-7.47,4A10.26,10.26,0,0,0,77.76,142a7,7,0,0,0-1.15,3.81c0,2.69.94,5.22,1.39,7.71a12.75,12.75,0,0,1,.25,3.73,7.81,7.81,0,0,1-1.1,3.36,28.89,28.89,0,0,1-4.08,4.75,12.12,12.12,0,0,0-2.81,4.18,5.57,5.57,0,0,0,0,3.73,4.1,4.1,0,0,0,1.38,1.93C72.1,175.54,72.39,175.63,72.37,175.66Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '85.72159004211426px 141.10499954223633px',
          }}
          id="el3z8kbfe17sj"
          className="animable"
        />
        <path
          d="M86.39,125a17.15,17.15,0,0,0,.88-3.87,16.89,16.89,0,0,0-.54-3.93,6.81,6.81,0,0,1-.34,7.8Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '87.092618227005px 121.0999984741211px',
          }}
          id="ele4exunajcdl"
          className="animable"
        />
        <path
          d="M91.6,157.48s-.13-.12-.36-.38a5.3,5.3,0,0,1-.76-1.34,8.48,8.48,0,0,1,.08-5.56c.68-2.33,2.47-4.6,4.24-7.13a18.16,18.16,0,0,0,2.28-4.22,16.24,16.24,0,0,0,.82-5.08c.06-3.56-.62-6.94-.83-10.06a18.29,18.29,0,0,1,1-8.24,10.25,10.25,0,0,1,3.29-4.5,7.42,7.42,0,0,1,1.32-.78,2,2,0,0,1,.5-.18,17.06,17.06,0,0,0-1.69,1.12,10.38,10.38,0,0,0-3.08,4.48,18.31,18.31,0,0,0-.82,8.07c.23,3.08.93,6.46.87,10.1a16.49,16.49,0,0,1-.86,5.24,18.26,18.26,0,0,1-2.37,4.32c-1.81,2.54-3.58,4.74-4.28,7a8.42,8.42,0,0,0-.24,5.38A8.26,8.26,0,0,0,91.6,157.48Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '96.61521100997925px 133.7449951171875px',
          }}
          id="elk9ea4l5nrt"
          className="animable"
        />
        <path
          d="M65.19,159.55s.1.16.29.46a3.25,3.25,0,0,0,1.14,1,4.24,4.24,0,0,0,2.34.48,4.16,4.16,0,0,0,2.78-1.39,6.64,6.64,0,0,0,1.56-3.51,11.55,11.55,0,0,0-.36-4.47c-.39-1.56-1-3.15-1.44-4.88a12.22,12.22,0,0,1-.41-5.51,10.35,10.35,0,0,1,2.57-4.9,24.08,24.08,0,0,1,3.87-3.37c1.31-1,2.62-1.78,3.78-2.63a26,26,0,0,0,3-2.56,11.27,11.27,0,0,0,3.08-4.76,15.79,15.79,0,0,0,.39-2.08,6,6,0,0,1-.19,2.13,11.15,11.15,0,0,1-3,5,25.68,25.68,0,0,1-3,2.65c-1.16.87-2.46,1.7-3.75,2.67A24.25,24.25,0,0,0,74,137.19a10,10,0,0,0-2.44,4.66,12.09,12.09,0,0,0,.39,5.29c.45,1.68,1,3.29,1.41,4.89a11.59,11.59,0,0,1,.32,4.65A6.86,6.86,0,0,1,72,160.37a4.43,4.43,0,0,1-3,1.43,4.37,4.37,0,0,1-2.46-.6,2.83,2.83,0,0,1-1.12-1.14,1.17,1.17,0,0,1-.17-.38C65.2,159.6,65.18,159.55,65.19,159.55Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '76.49594116210938px 141.61827087402344px',
          }}
          id="el09owwmj1ygen"
          className="animable"
        />
        <path
          d="M128.54,110.37c.76,5.16,2.16,10.26,4.39,13.46,1.79,2.56,5.28,4,5.81,7.14.45,2.6-1.11,5.19-.86,7.81.4,4.15,5,6.67,6.26,10.62,1.08,3.29-.41,7-2.92,9.4s-5.87,3.65-9.21,4.55c-4.77,1.29-10.56,1.68-14-1.88-2.35-2.45-2.87-6.07-3.17-9.44-.8-9-.77-18.11-.73-27.17"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '129.2950096130371px 137.3215732574463px',
          }}
          id="elonzmt4e53c"
          className="animable"
        />
        <path
          d="M97.35,119.05a15.52,15.52,0,0,1,14-17.39c8.28-.79,15.64,5.37,16.88,13.6,1.09,7.21,2,14.49,2,17.13-.1,8-4.77,11.08-6.66,12a10.65,10.65,0,0,1-2.09.52h0a.06.06,0,0,0-.05.06l1.77,9.15c.8,6-2.54,11.34-8.53,12.22s-10.7-3.73-11.62-9.73Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '113.72953224182129px 134.01986694335938px',
          }}
          id="elm5vs43wlho"
          className="animable"
        />
        <path
          d="M126.59,118.74c-.13.19-1.18-.38-2.53-.18s-2.24,1-2.41.88,0-.38.42-.76a3.52,3.52,0,0,1,1.9-.9,3.36,3.36,0,0,1,2,.34C126.48,118.38,126.66,118.66,126.59,118.74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '124.09462571144104px 118.60005050897598px',
          }}
          id="elqj2fgo91un9"
          className="animable"
        />
        <path
          d="M114.43,121.12c-.13.19-1.18-.38-2.53-.18s-2.24,1-2.41.88,0-.38.42-.76a3.52,3.52,0,0,1,1.9-.9,3.36,3.36,0,0,1,2,.34C114.31,120.76,114.5,121,114.43,121.12Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '111.93439197540283px 120.98006635904312px',
          }}
          id="elqtpxnjp6l9p"
          className="animable"
        />
        <path
          d="M119.48,128.9a9,9,0,0,1,2.13-.72c.34-.08.66-.2.68-.44a1.72,1.72,0,0,0-.38-1c-.44-.79-.91-1.61-1.4-2.47a46.44,46.44,0,0,1-3.29-6.53c.15-.08,1.85,2.72,3.81,6.25l1.36,2.49a2,2,0,0,1,.38,1.33.9.9,0,0,1-.5.59,2.06,2.06,0,0,1-.57.16A8.36,8.36,0,0,1,119.48,128.9Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '119.99779653549194px 123.31915760040283px',
          }}
          id="el2d48wa55t98"
          className="animable"
        />
        <path
          d="M121.37,144.93s-5.15,1.18-12.23-1.78c0,0,3,6.58,12.71,4.24Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '115.49499893188477px 145.52161145210266px',
          }}
          id="ellyft43ip3i"
          className="animable"
        />
        <path
          d="M119.38,132.23a2.47,2.47,0,0,0-2.31-.58,2.24,2.24,0,0,0-1.41,1,1.42,1.42,0,0,0,.13,1.63,1.65,1.65,0,0,0,1.83.19,5.09,5.09,0,0,0,1.57-1.28,1.5,1.5,0,0,0,.33-.46.45.45,0,0,0-.07-.5"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '117.51421117782593px 133.115678191185px',
          }}
          id="el1wej15vad28"
          className="animable"
        />
        <path
          d="M115.64,130.41c.22,0,.44,1.42,1.84,2.28s2.94.47,3,.67-.31.33-1,.45a3.73,3.73,0,0,1-2.47-.48,3.19,3.19,0,0,1-1.45-1.92C115.43,130.8,115.54,130.42,115.64,130.41Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '117.99351501464844px 132.13153719902039px',
          }}
          id="el1cf73kpw5aq"
          className="animable"
        />
        <path
          d="M113.74,117.27c-.08.38-1.46.41-3,.83s-2.77,1-3,.74,0-.52.52-1a5.43,5.43,0,0,1,4.6-1.2C113.43,116.84,113.77,117.08,113.74,117.27Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '110.69635891914368px 117.71932220458984px',
          }}
          id="el9ezcogtnlw"
          className="animable"
        />
        <path
          d="M125.45,115c-.19.34-1.17.16-2.29.31s-2,.51-2.3.22c-.11-.14,0-.47.36-.82A3.2,3.2,0,0,1,123,114a3.31,3.31,0,0,1,1.91.35C125.36,114.56,125.54,114.86,125.45,115Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '123.14584803581238px 114.80862790346146px',
          }}
          id="elfi8k6aqijta"
          className="animable"
        />
        <path
          d="M124.24,119.88a1.26,1.26,0,0,0,1,1.43,1.2,1.2,0,0,0,1.44-.94,1.26,1.26,0,0,0-1-1.43A1.2,1.2,0,0,0,124.24,119.88Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '125.46000254154205px 120.12500071525574px',
          }}
          id="el5mibb298pda"
          className="animable"
        />
        <path
          d="M111.9,122.18a1.24,1.24,0,0,0,1,1.43,1.2,1.2,0,0,0,1.45-.93,1.26,1.26,0,0,0-1-1.43A1.19,1.19,0,0,0,111.9,122.18Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '113.12353515625px 122.42892801761627px',
          }}
          id="elr7zjs2t5lve"
          className="animable"
        />
        <path
          d="M98.22,156.91,128.54,151l-.86,16.9s-13.49,4.19-14,4.44-9.32,0-9.32,0Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '113.37999725341797px 161.72555351257324px',
          }}
          id="elmjiq9m8hcvb"
          className="animable"
        />
        <path
          d="M64.62,271.7c-.23.77-.47,1.67-.71,2.76a8.21,8.21,0,0,0-.12,2.84,12.45,12.45,0,0,0,.79,3.44c.49,1-.46,2-1.34,1.59s-2.3-3.1-2.42-6.61-3.46.9-4.7,2.48-5.32,6.3-6.11,6.31c-1.16,0-1.38-1.24-.1-2.79s4.79-6.48,3.92-7.1-7.08,7.54-7.08,7.54-1,2-2.07,1.28c-1.85-1.22,5.4-9.4,6.11-10.16.49-.53-.43-1.23-.93-.63s-6,8.27-7.91,7c-1.46-.95,5.9-6.78,6.16-9s-5.13,5-6.48,4c-.51-.36-.83-.69,2.86-4.39,1.79-1.79,8.68-7.23,8.68-7.23l14-48.85H85.52Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '63.42196846008301px 249.3450164794922px',
          }}
          id="el59coan3d7ny"
          className="animable"
        />
        <path
          d="M153.79,143.9s26.15-10.4,30.3-13.61,30.25-26.68,30.25-26.68l3.47-2.92c.43-.67.91-1.48,1.44-2.46a8.28,8.28,0,0,0,.89-2.69,12.92,12.92,0,0,0,.19-3.54,1.1,1.1,0,0,1,1.72-1.16c.72.68,1.36,3.61.52,7s3.57.09,5.2-1.1,6.84-4.6,7.6-4.38c1.12.31,1,1.56-.67,2.7s-6.38,4.92-5.71,5.75,8.87-5.31,8.87-5.31,1.54-1.59,2.34-.66c1.45,1.68-7.76,7.56-8.65,8.1-.62.37.07,1.3.71.86s8.05-6.3,9.54-4.6c1.14,1.3-7.53,4.9-8.39,7s6.3-3.4,7.34-2.11c.39.48.61.89-3.95,3.44-2.22,1.23-10.34,4.57-10.34,4.57l-.86.89L190.83,149l-31.92,12.77Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '197.8465576171875px 126.19673156738281px',
          }}
          id="elgm60yyc6b7"
          className="animable"
        />
        <path
          d="M56,418.21,50.9,441.36l-9.33,17.15a2.43,2.43,0,0,0,1.12,3.37h0a2.42,2.42,0,0,0,2.22-.1c4.34-2.51,20.26-11.82,20.54-13.53.33-2,7-24.07,7-24.07Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '56.862128257751465px 440.1561508178711px',
          }}
          id="elqkv2girgr8"
          className="animable"
        />
        <g id="el7bfroilfjq7">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '54.26499366760254px 454.40058040618896px',
            }}
            className="animable"
          >
            <path
              d="M42.69,461.88l23.15-15.19-.24,1a3.66,3.66,0,0,1-1.41,2.09c-1.88,1.36-7.17,5-19.21,12a2.45,2.45,0,0,1-2.29.09Z"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '54.26499366760254px 454.40058040618896px',
              }}
              id="elxogppumglw"
              className="animable"
            />
          </g>
        </g>
        <g id="elro1zss3h4e">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '63.403725385665894px 439.4121695756912px',
            }}
            className="animable"
          >
            <path
              d="M62.93,438.1a1.48,1.48,0,0,0-.85,1.77,1.42,1.42,0,0,0,1.75.86,1.56,1.56,0,0,0,.89-1.88,1.47,1.47,0,0,0-1.92-.69"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '63.403725385665894px 439.4121695756912px',
              }}
              id="el9yw2d1e0v55"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M50.42,453.11a7.42,7.42,0,0,0-1.58-2.29,7.42,7.42,0,0,0-2.53-1.16c0-.06.33-.17.89-.11a3.78,3.78,0,0,1,2,.87,3.82,3.82,0,0,1,1.21,1.79C50.53,452.75,50.48,453.1,50.42,453.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '48.396650314331055px 451.32131004333496px',
          }}
          id="elzxv7cytu22"
          className="animable"
        />
        <path
          d="M48,455.79c-.13.07-.69-.86-1.8-1.49s-2.17-.69-2.17-.85a2.7,2.7,0,0,1,2.44.4C47.75,454.58,48.16,455.75,48,455.79Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '46.03144812583923px 454.5562138557434px',
          }}
          id="elj5ime5ils4p"
          className="animable"
        />
        <path
          d="M54.44,449.9a23.47,23.47,0,0,0-2.62-2.49,22.8,22.8,0,0,0-3.22-1.63A5.39,5.39,0,0,1,52.12,447,5.3,5.3,0,0,1,54.44,449.9Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '51.51999855041504px 447.83947348594666px',
          }}
          id="elv1mfib794ja"
          className="animable"
        />
        <path
          d="M56.59,443c-.1.13-1.24-.72-2.88-1.18s-3.05-.39-3.07-.55a4.72,4.72,0,0,1,3.21.05A4.67,4.67,0,0,1,56.59,443Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '53.61500549316406px 442.0132396221161px',
          }}
          id="elz12ej9pk67"
          className="animable"
        />
        <path
          d="M58.26,436.23a12,12,0,0,0-3-1.31,11.85,11.85,0,0,0-3.24,0c0-.06.29-.29.9-.46a5.16,5.16,0,0,1,2.45-.07,5.23,5.23,0,0,1,2.21,1C58.11,435.85,58.31,436.19,58.26,436.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '55.1437087059021px 435.25266456604004px',
          }}
          id="elamx3emw39l"
          className="animable"
        />
        <path
          d="M55.66,433.64a2,2,0,0,1,.18-.88,6.36,6.36,0,0,1,1.25-2.11,2.82,2.82,0,0,1,1.47-1,1,1,0,0,1,1,.48,1.59,1.59,0,0,1,.11,1.13A3.42,3.42,0,0,1,56,433.62a4,4,0,0,1-3.3-2.95,1.33,1.33,0,0,1,.21-1.13,1,1,0,0,1,1.09-.26,3.42,3.42,0,0,1,1.33,1.16,7.21,7.21,0,0,1,1.13,2.18,2.11,2.11,0,0,1,.16.88A11.56,11.56,0,0,0,55,430.67a3.29,3.29,0,0,0-1.18-1,.51.51,0,0,0-.6.14,1,1,0,0,0-.09.75,3.56,3.56,0,0,0,2.89,2.53,3,3,0,0,0,3.16-2,1.17,1.17,0,0,0,0-.79.53.53,0,0,0-.55-.27,2.46,2.46,0,0,0-1.26.82A9,9,0,0,0,55.66,433.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '56.19050717353821px 431.4302806854248px',
          }}
          id="elcii2h2iu0ji"
          className="animable"
        />
        <path
          d="M128.2,426.74l-.7,18.54s18.61,6.94,18.81,10.38l-36-.07-.09-28.94Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '128.26499938964844px 441.1549987792969px',
          }}
          id="eltb1aefyrjo"
          className="animable"
        />
        <g id="ela17847wz9ht">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '116.73123598098755px 445.0184222459793px',
            }}
            className="animable"
          >
            <path
              d="M116.37,443.7a1.46,1.46,0,0,0-1,1.67,1.42,1.42,0,0,0,1.65,1,1.55,1.55,0,0,0,1.07-1.78,1.47,1.47,0,0,0-1.83-.88"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '116.73123598098755px 445.0184222459793px',
              }}
              id="elcfd2r3fmlym"
              className="animable"
            />
          </g>
        </g>
        <g id="el6akevz50l6b">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '128.31706047058105px 454.16497802734375px',
            }}
            className="animable"
          >
            <path
              d="M110.31,455.59l.11-2.92,34.47,1.16s1.6.7,1.42,1.83Z"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '128.31706047058105px 454.16497802734375px',
              }}
              id="eldbkajxsmusr"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M128.08,445.1c0,.17-.88.25-1.75.81s-1.33,1.3-1.49,1.24.1-1.09,1.16-1.75S128.12,444.94,128.08,445.1Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '126.43885958194733px 446.0473619699478px',
          }}
          id="elbqwo0k5lw4u"
          className="animable"
        />
        <path
          d="M131.85,446.67c0,.17-.72.46-1.32,1.21s-.77,1.52-.94,1.52-.29-1,.47-1.92S131.85,446.5,131.85,446.67Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '130.65655541419983px 447.99749779701233px',
          }}
          id="el5czhc6e8xbe"
          className="animable"
        />
        <path
          d="M134,451.19c-.16,0-.4-.84,0-1.8s1.28-1.35,1.35-1.2-.44.66-.8,1.45S134.16,451.17,134,451.19Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '134.56880450248718px 449.67442750930786px',
          }}
          id="elr3alwhh27xl"
          className="animable"
        />
        <path
          d="M127.77,440.85c-.07.16-.88-.08-1.87,0s-1.77.38-1.86.23.65-.78,1.83-.84S127.86,440.72,127.77,440.85Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '125.90471041202545px 440.6783874332905px',
          }}
          id="elkndt5woxter"
          className="animable"
        />
        <g id="el9f7tizcnrg">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '119.14500045776367px 432.05999755859375px',
            }}
            className="animable"
          >
            <polygon
              points="128.06 430.41 127.94 433.71 110.24 433.52 110.23 430.54 128.06 430.41"
              id="eliqamj637ro"
              style={{
                transformOrigin: '119.14500045776367px 432.05999755859375px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M127.85,437.11a3.46,3.46,0,0,1-1.81,0,8.64,8.64,0,0,1-2.92-1.14,2.09,2.09,0,0,1-.54-.42.79.79,0,0,1-.08-.94,1,1,0,0,1,.77-.4,2.27,2.27,0,0,1,.68.1,6.17,6.17,0,0,1,2.78,1.48c.83.77,1.12,1.43,1.06,1.46s-.49-.49-1.34-1.13a7,7,0,0,0-1.6-.91,6.64,6.64,0,0,0-1-.32c-.38-.1-.7-.1-.8.07s0,.09,0,.2a1.79,1.79,0,0,0,.4.31,7.64,7.64,0,0,0,1,.54,10.12,10.12,0,0,0,1.74.68A12.44,12.44,0,0,1,127.85,437.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '125.11571502685547px 435.73057293891907px',
          }}
          id="elvcpizo0mafi"
          className="animable"
        />
        <path
          d="M127.62,437.36c-.07,0-.41-.6-.48-1.74a6.33,6.33,0,0,1,.25-2,6.86,6.86,0,0,1,.47-1.1,1.51,1.51,0,0,1,1.15-.91.85.85,0,0,1,.75.51,2.26,2.26,0,0,1,.18.66,3.78,3.78,0,0,1,0,1.21,4.16,4.16,0,0,1-.77,1.87c-.71.93-1.44,1.14-1.46,1.08s.56-.43,1.1-1.33a4.06,4.06,0,0,0,.57-1.69,3.65,3.65,0,0,0,0-1c0-.38-.2-.69-.34-.65s-.48.28-.63.59a6,6,0,0,0-.45,1,6.13,6.13,0,0,0-.35,1.8C127.53,436.68,127.71,437.34,127.62,437.36Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '128.56236124038696px 434.48497009277344px',
          }}
          id="el66xn6aucywo"
          className="animable"
        />
        <path
          d="M93.07,223.18s-11.38,18-13,24.86c-1.47,6.17-26.37,140.25-31.52,168a5.67,5.67,0,0,0,3.95,6.47L75,429.29A5.69,5.69,0,0,0,82.19,425L110,295.14l-8.13,128.7a6.58,6.58,0,0,0,6.78,7l22.06-.68A6.59,6.59,0,0,0,137,424c1.92-31,10.54-172,8.81-176.41-1.95-5-7.06-22.26-7.06-22.26Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '97.24577713012695px 327.0117645263672px',
          }}
          id="elo1qo9mk945d"
          className="animable"
        />
        <path
          d="M84.07,418.69a6.9,6.9,0,0,1-1.38-.17c-.89-.14-2.16-.38-3.72-.7-3.13-.64-7.42-1.65-12.11-3S58,412,55,410.85c-1.49-.57-2.69-1.05-3.51-1.41a8,8,0,0,1-1.26-.59,6.8,6.8,0,0,1,1.33.41l3.57,1.24c3,1.05,7.18,2.44,11.85,3.8s8.94,2.43,12,3.16l3.68.86A8.58,8.58,0,0,1,84.07,418.69Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '67.14999961853027px 413.77000427246094px',
          }}
          id="elxw2c6sy6v2j"
          className="animable"
        />
        <path
          d="M56.15,410.47A3.77,3.77,0,0,1,54.72,408a3.89,3.89,0,0,1,.18-2.83c.16,0,0,1.27.33,2.72S56.27,410.38,56.15,410.47Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '55.34930247068405px 407.8199920654297px',
          }}
          id="elcj9hwmz5j6v"
          className="animable"
        />
        <path
          d="M58.92,405.69a4.78,4.78,0,0,1-.27,2.66,4.66,4.66,0,0,1-1.24,2.36,13.66,13.66,0,0,1,.74-2.51A12.92,12.92,0,0,1,58.92,405.69Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '58.20460081100464px 408.1999969482422px',
          }}
          id="el5pfq10pfoe"
          className="animable"
        />
        <path
          d="M129.58,412.47a5.74,5.74,0,0,1,.64,2.34,5.57,5.57,0,0,1,.13,2.43,11.47,11.47,0,0,1-.77-4.77Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '129.9958324432373px 414.8550109863281px',
          }}
          id="el1gc7y7f2qbo"
          className="animable"
        />
        <path
          d="M132.27,411.21a12.53,12.53,0,0,1-.07,5,6.11,6.11,0,0,1-.23-2.52A6.17,6.17,0,0,1,132.27,411.21Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '132.20800045132637px 413.7099914550781px',
          }}
          id="el777btgo0oe5"
          className="animable"
        />
        <path
          d="M119.86,229.45a2.73,2.73,0,0,1,0,.71c0,.51,0,1.19-.07,2-.07,1.76-.23,4.3-.45,7.44-.46,6.28-1.32,14.95-2.72,24.45s-3,18.06-4.32,24.22c-.64,3.08-1.18,5.57-1.58,7.29-.19.81-.35,1.47-.46,2a4.13,4.13,0,0,1-.2.68,3,3,0,0,1,.09-.7c.1-.51.22-1.17.37-2,.35-1.78.83-4.27,1.42-7.31,1.19-6.18,2.77-14.73,4.17-24.22s2.31-18.14,2.86-24.41c.25-3.09.46-5.61.62-7.42.07-.83.12-1.51.17-2A4.38,4.38,0,0,1,119.86,229.45Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '114.9715929031372px 263.8449935913086px',
          }}
          id="elo2eff0uqtp"
          className="animable"
        />
        <path
          d="M140,229.43a1.65,1.65,0,0,1-.5.06l-1.45.07c-1.25.05-3.07.1-5.32.14-4.49.07-10.7.07-17.56-.12s-13.06-.54-17.54-.86c-2.25-.17-4.06-.31-5.31-.44l-1.44-.15a1.71,1.71,0,0,1-.5-.09,2,2,0,0,1,.51,0l1.45.06,5.31.27c4.48.23,10.68.51,17.53.71s13.06.25,17.55.27l5.32,0,1.45,0A1.51,1.51,0,0,1,140,229.43Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '115.19000244140625px 228.88328862190247px',
          }}
          id="elw7f3qjhgvc"
          className="animable"
        />
        <path
          d="M123.69,229.21a11.17,11.17,0,0,1,0,1.7c0,1.18-.09,2.74-.15,4.63-.15,3.91-.39,9.3-.7,15.26-.16,3-.27,5.82-.47,8.41a16.54,16.54,0,0,1-1.75,6.68,8.77,8.77,0,0,1-3.2,3.37,6,6,0,0,1-1.16.52,2.17,2.17,0,0,1-.44.09c0-.06.59-.19,1.49-.78a9,9,0,0,0,3-3.38,16.63,16.63,0,0,0,1.59-6.54c.17-2.57.27-5.42.43-8.39.31-6,.61-11.36.85-15.26.13-1.88.24-3.44.32-4.62A10.31,10.31,0,0,1,123.69,229.21Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '119.77119302749634px 249.53998565673828px',
          }}
          id="elxi4r992z3ak"
          className="animable"
        />
        <path
          d="M98,240.31a3.84,3.84,0,0,1,0,1.16,16.67,16.67,0,0,1-.56,3.11,18.91,18.91,0,0,1-14.56,13.6,16.57,16.57,0,0,1-3.14.34,3.81,3.81,0,0,1-1.16-.08,39.13,39.13,0,0,0,4.22-.62,19.43,19.43,0,0,0,14.29-13.35A41.17,41.17,0,0,0,98,240.31Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '88.31203174591064px 249.4217643737793px',
          }}
          id="elrg4e62x90tq"
          className="animable"
        />
        <path
          d="M145.7,259.13s-.29,0-.79-.2a11.89,11.89,0,0,1-2-.88,16.88,16.88,0,0,1-2.73-1.83,19.37,19.37,0,0,1-2.81-2.89,19,19,0,0,1-2.08-3.46,16.61,16.61,0,0,1-1.06-3.11,12.49,12.49,0,0,1-.34-2.18,2.64,2.64,0,0,1,0-.82c.1,0,.18,1.14.68,2.91a18.42,18.42,0,0,0,1.15,3,20,20,0,0,0,2.06,3.34,20.58,20.58,0,0,0,2.7,2.85,19.4,19.4,0,0,0,2.6,1.87C144.64,258.66,145.73,259,145.7,259.13Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '139.77929496765137px 251.44499969482422px',
          }}
          id="els4xjsk7lm3p"
          className="animable"
        />
        <path
          d="M105.66,243.58s0,.16,0,.45-.1.76-.17,1.32c-.16,1.17-.39,2.86-.69,5-.6,4.37-1.55,10.69-2.78,18.49-2.45,15.59-6.2,37.08-11,60.67S81,374.36,77.1,389.66c-1.95,7.64-3.58,13.82-4.76,18.07-.58,2.11-1,3.76-1.35,4.9l-.37,1.27a3.74,3.74,0,0,1-.14.43s0-.15.09-.44.18-.74.32-1.29c.29-1.15.71-2.8,1.26-4.92,1.11-4.27,2.69-10.46,4.59-18.11,3.81-15.32,8.81-36.54,13.68-60.13s8.65-45.06,11.2-60.63c1.28-7.79,2.27-14.1,2.94-18.46.34-2.16.6-3.85.79-5l.21-1.3C105.62,243.73,105.66,243.58,105.66,243.58Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '88.06999206542969px 328.95499420166016px',
          }}
          id="el0sbtplnc4dwe"
          className="animable"
        />
        <path
          d="M124,418.56a3.31,3.31,0,0,1,0-.42c0-.31.06-.72.09-1.24.1-1.12.23-2.72.41-4.78.37-4.16.91-10.15,1.57-17.53,1.32-14.81,3.39-35.25,4.95-57.87.77-11.32,1.29-22.11,1.51-31.94s.16-18.67,0-26.1-.57-13.43-.86-17.58c-.15-2.05-.26-3.65-.35-4.77,0-.53-.05-.94-.07-1.24a2,2,0,0,1,0-.43,2.29,2.29,0,0,1,.06.42c0,.3.07.71.13,1.24.1,1.12.25,2.72.44,4.77.36,4.14.75,10.15,1,17.58s.35,16.29.14,26.12-.7,20.64-1.47,32c-1.56,22.64-3.69,43.07-5.1,57.87-.74,7.38-1.33,13.36-1.74,17.52-.22,2.05-.38,3.65-.5,4.77-.06.52-.11.93-.14,1.23A2.78,2.78,0,0,1,124,418.56Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '128.56361865997314px 336.6100082397461px',
          }}
          id="elzvq4kk43cwm"
          className="animable"
        />
        <path
          d="M137.61,416.23c0,.15-7.9,1.14-17.69,2.21s-17.74,1.84-17.76,1.7,7.91-1.14,17.7-2.21S137.6,416.09,137.61,416.23Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '119.88497924804688px 418.185005903244px',
          }}
          id="elhjl91rhwmg"
          className="animable"
        />
        <path
          d="M107.88,105.47a13,13,0,0,0-2.17,12.92c1.13,2.88,3.34,5.52,3.15,8.61-.23,3.83-4.14,6.82-3.92,10.65.24,4.32,5.76,7,5.76,11.36s-2.66,6.06-7.79,7c-3.29.6-5.12-3.47-6.75-6.39S94,143.3,93.66,140a98,98,0,0,1-.25-16.61c.3-4.47,1-9.06,3.29-12.89a16.71,16.71,0,0,1,11-7.65"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '101.93566608428955px 129.45973014831543px',
          }}
          id="elkungdrb2yzr"
          className="animable"
        />
        <path
          d="M129.75,113.47c-1.65,2.52-6.88,1-10-.77a7.53,7.53,0,0,1-10.27-2.12c-1.81,2.3-5.48,1.54-6.82-1s-.59-6.17,1.25-8.45a11.86,11.86,0,0,1,7.19-3.91,16.68,16.68,0,0,1,16.94,7c1.74,2.63,2.79,6.17,1.75,9.32"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '116.09056758880615px 105.86015033721924px',
          }}
          id="elhzcf6gtr5aj"
          className="animable"
        />
        <path
          d="M129.8,113c-.09.06-1-1.57-3-3.79a20.66,20.66,0,0,0-9.5-6.22,16.09,16.09,0,0,0-11.19.86,13.68,13.68,0,0,0-3.78,2.87s0-.11.17-.29a5.42,5.42,0,0,1,.61-.75,10,10,0,0,1,2.83-2.15,15.85,15.85,0,0,1,11.5-1,18.78,18.78,0,0,1,5.79,2.87,22.3,22.3,0,0,1,3.85,3.61,21.71,21.71,0,0,1,2.06,2.88A5.88,5.88,0,0,1,129.8,113Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '116.06499862670898px 107.44392776489258px',
          }}
          id="el8su83jlu0i6"
          className="animable"
        />
        <path
          d="M114.27,114c-.08,0-.28-.89-.9-2.22a10.48,10.48,0,0,0-3.59-4.34,8,8,0,0,0-5.4-1.26,14.4,14.4,0,0,0-2.29.63s.16-.18.53-.39a5.8,5.8,0,0,1,1.7-.61,7.89,7.89,0,0,1,5.75,1.19,9.94,9.94,0,0,1,3.63,4.63A6,6,0,0,1,114.27,114Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '108.18000030517578px 109.84321355819702px',
          }}
          id="eltb44ha7z13"
          className="animable"
        />
        <path
          d="M98.22,156.91s-13.5,3.85-18.55,12.17S59,236,59,236l17.86,2,14.86-39,3.67,12.19-2.34,12,45.72,2.14L142,172.78,190.83,149l5.5-5.7-14.2-15-5.42,5.06-49,17.95s1.82,14.48-11.39,16.58S98.22,156.91,98.22,156.91Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '127.66500091552734px 183.1500015258789px',
          }}
          id="elispwtla8s0e"
          className="animable"
        />
        <rect
          x="124.34"
          y="176.54"
          width="10.88"
          height="2.83"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '129.78px 177.95499999999998px',
          }}
          id="elv2aabcgxnla"
          className="animable"
        />
        <path
          d="M86.67,181.69c.14,0,2.18,6.38,4.57,14.35s4.2,14.45,4.06,14.5-2.18-6.39-4.56-14.35S86.53,181.73,86.67,181.69Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '90.98503160476685px 196.11515045166016px',
          }}
          id="elxdwwm8pqdc"
          className="animable"
        />
        <path
          d="M150.74,161.29a33.63,33.63,0,0,0-5.5,5.37,32.85,32.85,0,0,0-3.65,6.77,6.84,6.84,0,0,1,.57-2.22,19.2,19.2,0,0,1,6.6-8.76A7,7,0,0,1,150.74,161.29Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '146.16502380371094px 167.35999298095703px',
          }}
          id="ellyeb8cucaec"
          className="animable"
        />
        <g id="elzqhf07sqngi">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '88.80842781066895px 194.97998046875px',
            }}
            className="animable"
          >
            <path
              d="M87.53,184.45a71,71,0,0,0-1.55,15,12.42,12.42,0,0,0,.43,3.7,4.72,4.72,0,0,0,2.23,2.87c1.35-1.94,2.75-4,3-6.36a13.55,13.55,0,0,0-.77-4.86q-1.54-5.43-3.1-10.86"
              id="elm8s3g63xzy"
              style={{
                transformOrigin: '88.80842781066895px 194.97998046875px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M99.5,154.08c2.42,1.69,3.23,4.94,3.12,7.88s-1,5.82-1.11,8.77.61,6.19,3,7.94l11.62-3.94c-2.29-1.31-2.77-4.45-2.27-7s1.71-5,1.84-7.66c.37-6.91-4.6-12.81-6.92-15.62"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '107.81500244140625px 161.5600128173828px',
          }}
          id="el5zyy2xoa2av"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-2--inject-211"
        style={{ transformOrigin: '207.41756439208984px 265.6168746948242px' }}
        className="animable"
      >
        <polygon
          points="147.21 430.32 142.71 456.06 164.97 456.06 167.43 431.72 147.21 430.32"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '155.06999969482422px 443.19000244140625px',
          }}
          id="ely3c1m5xp4n"
          className="animable"
        />
        <path
          d="M165.42,454a15.5,15.5,0,0,1-3.24.19c-2,0-4.77,0-7.82-.15l-7.81-.33a17.4,17.4,0,0,1-3.24-.26,15.93,15.93,0,0,1,3.25-.17c2,0,4.77,0,7.82.15l7.81.32A17.88,17.88,0,0,1,165.42,454Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '154.364990234375px 453.733353972435px',
          }}
          id="elrd5t2kqlpxk"
          className="animable"
        />
        <g id="elinw457bu8mm">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '153.94499969482422px 454.72999572753906px',
            }}
            className="animable"
          >
            <polyline
              points="142.71 456.06 164.97 456.06 165.18 453.95 143.11 453.4 142.71 455.81"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '153.94499969482422px 454.72999572753906px',
              }}
              id="elfrvep42y15i"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M153.58,453.94a90.47,90.47,0,0,1,1.22-9.82,93.38,93.38,0,0,1,1.73-9.73,93.57,93.57,0,0,1-1.22,9.81A97.22,97.22,0,0,1,153.58,453.94Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '155.05500030517578px 444.1649932861328px',
          }}
          id="elp1o9361uwai"
          className="animable"
        />
        <path
          d="M164.19,453.9a10.67,10.67,0,0,0-.38-4.67,9.23,9.23,0,0,0-2.81-4.15,9,9,0,0,0-5.73-2,9.43,9.43,0,0,0-5.79,1.88,10.26,10.26,0,0,0-3.1,4,12.84,12.84,0,0,0-1,4.61s0-.11-.07-.33a6.5,6.5,0,0,1,0-1,9.85,9.85,0,0,1,.74-3.46,10.33,10.33,0,0,1,3.15-4.2,9.78,9.78,0,0,1,6.09-2,9.13,9.13,0,0,1,8.88,6.59,8.6,8.6,0,0,1,.33,3.52,5.19,5.19,0,0,1-.18.95C164.25,453.8,164.21,453.91,164.19,453.9Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '154.92307090759277px 448.23963499069214px',
          }}
          id="elr0x72hgbzc"
          className="animable"
        />
        <path
          d="M242.94,423.13l5.41,17.74s19.86.46,21.18,3.64l-34,11.73-9.57-27.3Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '247.7449951171875px 439.6850128173828px',
          }}
          id="elqo8qwom7859"
          className="animable"
        />
        <g id="elur7r3o0j498">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '238.0742893218994px 444.17780780792236px',
            }}
            className="animable"
          >
            <path
              d="M237.32,443a1.47,1.47,0,0,0-.41,1.91,1.4,1.4,0,0,0,1.89.43,1.54,1.54,0,0,0,.43-2,1.46,1.46,0,0,0-2-.23"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '238.0742893218994px 444.17780780792236px',
              }}
              id="elmd7jvzezpxj"
              className="animable"
            />
          </g>
        </g>
        <g id="elhbbqyqlfpwm">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '252.08499908447266px 449.74497985839844px',
            }}
            className="animable"
          >
            <path
              d="M235.5,456.24l-.86-2.79,32.95-10.2s1.74.14,1.94,1.26Z"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '252.08499908447266px 449.74497985839844px',
              }}
              id="elqcvxzf9ziub"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M248.85,440.51c.05.17-.76.53-1.39,1.35s-.83,1.66-1,1.65-.26-1.06.52-2S248.83,440.34,248.85,440.51Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '247.59818494319916px 441.98427724838257px',
          }}
          id="ely4fsikbv8me"
          className="animable"
        />
        <path
          d="M252.92,440.75c.1.15-.52.68-.85,1.58s-.23,1.7-.39,1.75-.6-.86-.18-2S252.87,440.6,252.92,440.75Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '252.12706565856934px 442.3992899656296px',
          }}
          id="el3mcmv63igde"
          className="animable"
        />
        <path
          d="M256.42,444.33c-.13.09-.65-.66-.54-1.72s.77-1.69.88-1.58-.19.77-.27,1.64S256.58,444.25,256.42,444.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '256.3244065642357px 442.67745864391327px',
          }}
          id="elsjtwkua10m"
          className="animable"
        />
        <path
          d="M247.16,436.6c0,.18-.86.21-1.77.6s-1.55.93-1.69.82.37-.95,1.45-1.39S247.2,436.44,247.16,436.6Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '245.41923546791077px 437.2087404727936px',
          }}
          id="el21fz32jk6r9i"
          className="animable"
        />
        <g id="elershvgymjhv">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '236.09500122070312px 431.03001403808594px',
            }}
            className="animable"
          >
            <polygon
              points="244.01 426.64 244.98 429.8 228.2 435.42 227.21 432.61 244.01 426.64"
              id="elmftxumuwpv"
              style={{
                transformOrigin: '236.09500122070312px 431.03001403808594px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M246,433a3.39,3.39,0,0,1-1.71.58,8.28,8.28,0,0,1-2,.07,9.6,9.6,0,0,1-1.16-.18,2.49,2.49,0,0,1-.66-.23.77.77,0,0,1-.38-.86,1,1,0,0,1,.6-.63,2.62,2.62,0,0,1,.67-.13,6.75,6.75,0,0,1,1.19,0,6.11,6.11,0,0,1,1.92.49c1,.46,1.53,1,1.48,1s-.62-.31-1.63-.64a7.41,7.41,0,0,0-1.81-.33,6.75,6.75,0,0,0-1.09,0c-.39,0-.7.13-.73.32s0,.1.1.18a1.58,1.58,0,0,0,.48.16q.56.13,1.08.21a10,10,0,0,0,1.86.06A13.65,13.65,0,0,1,246,433Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '243.033855676651px 432.63720440864563px',
          }}
          id="elem0hm6a814u"
          className="animable"
        />
        <path
          d="M245.87,433.35c-.05,0-.58-.43-1-1.49a5.87,5.87,0,0,1-.41-1.94,6.11,6.11,0,0,1,.08-1.19,1.47,1.47,0,0,1,.79-1.23.84.84,0,0,1,.88.23,2.59,2.59,0,0,1,.39.56,4.21,4.21,0,0,1,.27,3.16c-.36,1.11-1,1.55-1,1.5a13.34,13.34,0,0,0,.6-1.61,4.15,4.15,0,0,0,0-1.79,3.4,3.4,0,0,0-.37-1c-.18-.34-.41-.59-.54-.51s-.36.43-.4.77a5.61,5.61,0,0,0-.1,1.07,6.76,6.76,0,0,0,.25,1.81C245.56,432.74,246,433.3,245.87,433.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '245.75818240642548px 430.40414452552795px',
          }}
          id="eldnxdghh1pbt"
          className="animable"
        />
        <path
          d="M143.14,198.81,136.73,212a16.16,16.16,0,0,0,2.64,18h0a16.17,16.17,0,0,0,13.71,5.11L178,232.27l0-14.82-24.52.71,6.13-10.79Z"
          style={{
            fill: 'rgb(183, 136, 118)',
            transformOrigin: '156.55252647399902px 217.01136589050293px',
          }}
          id="elkuxyvo7v9vn"
          className="animable"
        />
        <path
          d="M174.71,151.9c-4.11-6.94-5.29-16.19-6.33-24.19-.49-3.77-1.35-9.13,1.3-11.49,2.84-2.52,3.11-6.41,6.37-8.36s7.68-2.11,10.76.12"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '177.3282699584961px 129.12622451782227px',
          }}
          id="el3nm9jbwprgv"
          className="animable"
        />
        <path
          d="M186.09,176.5h0a11.14,11.14,0,0,0,12-10.65c.25-6.06.47-12.19.47-12.19s9.2-.84,9.89-9.93.45-30.1.45-30.1h0a31.69,31.69,0,0,0-32,2l.48,32-.06,17.23C177.35,170.61,180.34,176,186.09,176.5Z"
          style={{
            fill: 'rgb(183, 136, 118)',
            transformOrigin: '192.92018508911133px 143.3783416748047px',
          }}
          id="elzolhlo07ktc"
          className="animable"
        />
        <path
          d="M199.44,132.6c-1.57-1.95-4.11-2.74-6.21-1.38a5.29,5.29,0,0,0-1.78,6.61,7,7,0,0,0,4.45,3.38,3.5,3.5,0,0,1,2.72,3.77c-.27,2.29-4.07,3.13-5.79,5-2.67,2.93-8.53,4.16-12.47,4.61s-3.41.48-5.65-2.71a12.16,12.16,0,0,1-2.19-7.39l-.36-20.12a29,29,0,0,1,.48-7.22,9.72,9.72,0,0,1,3.82-6c2.22-1.45,5-1.56,7.55-2.37,3.15-1,5.83-3.09,8.78-4.59s6.57-2.39,9.53-.9c2.12,1.07,3.54,3.2,5.6,4.38,2.93,1.68,6.94,1.31,8.35,5.64a7.33,7.33,0,0,1-.06,4.63c-2,5.88-9.31,8.23-14.55,5.67-.1,1,.87,3.22-.19,6.36-.34,1-.46,2.54-2,2.57"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '194.36294555664062px 128.66566276550293px',
          }}
          id="eltd3cglb6cq"
          className="animable"
        />
        <path
          d="M197.79,138.27s0,.17-.12.39a1.36,1.36,0,0,1-1,.51,2.51,2.51,0,0,1-2.35-2.52,2.59,2.59,0,0,1,.68-1.92,2.69,2.69,0,0,1,1.42-.82c.94-.19,1.48.15,1.44.21s-.56,0-1.31.23a2.29,2.29,0,0,0-1.58,2.27,2.14,2.14,0,0,0,1.71,2.09C197.42,138.75,197.73,138.21,197.79,138.27Z"
          style={{
            fill: 'rgb(124, 81, 66)',
            transformOrigin: '196.08840382099152px 136.51144695281982px',
          }}
          id="el9e68ph148a"
          className="animable"
        />
        <path
          d="M175.41,117.42a10.65,10.65,0,1,0-14.58-7.2,2.65,2.65,0,0,1,0,1.88c-.39.67-1.3.76-2,1-2.57,1-2.92,4.89-1,6.9s5,2.29,7.68,1.58c-.65,2.33,1.45,4.83,3.86,5.11a6.72,6.72,0,0,0,6.1-3.24,15.26,15.26,0,0,0,2.07-6.91"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '169.2131643295288px 111.8494234085083px',
          }}
          id="el10cdaevd2kt"
          className="animable"
        />
        <path
          d="M181.58,106.36a2.91,2.91,0,0,1,0,.92,13.77,13.77,0,0,1-.36,2.52A15.26,15.26,0,0,1,170,121.13a13.68,13.68,0,0,1-2.51.36,2.62,2.62,0,0,1-.93,0c0-.09,1.32-.11,3.35-.68a15.82,15.82,0,0,0,11-11.07C181.47,107.68,181.48,106.35,181.58,106.36Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '174.08830070495605px 113.94577312469482px',
          }}
          id="elwumyuu3kfq"
          className="animable"
        />
        <path
          d="M171.5,97.93s.09-.06.27-.1a2.93,2.93,0,0,1,.83-.09,4.91,4.91,0,0,1,2.87,1.09,6.21,6.21,0,0,1,1.43,1.6,7.06,7.06,0,0,1,.88,2.3,13.29,13.29,0,0,1-.22,5.55,22.52,22.52,0,0,1-4.27,9,19,19,0,0,1-2,2.24,3.74,3.74,0,0,1-.87.7c-.07-.07,1.13-1.12,2.63-3.16a24.18,24.18,0,0,0,4.05-8.94,13.23,13.23,0,0,0,.26-5.34,7,7,0,0,0-.78-2.18,6,6,0,0,0-1.29-1.53A4.94,4.94,0,0,0,172.59,98C171.9,97.88,171.5,98,171.5,97.93Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '174.19534587860107px 108.97911167144775px',
          }}
          id="el691vh5wqdrp"
          className="animable"
        />
        <path
          d="M160.42,112.44s.08-.27.33-.68a9,9,0,0,1,1.27-1.61,10.69,10.69,0,0,1,12.57-2,9.52,9.52,0,0,1,1.71,1.12c.37.31.54.51.52.54s-.85-.64-2.39-1.33a11,11,0,0,0-12.16,2C161,111.56,160.5,112.49,160.42,112.44Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '168.62079048156738px 109.69207334518433px',
          }}
          id="el712h0j4i8yc"
          className="animable"
        />
        <path
          d="M178.32,116c.05-.06,1.2.87,3.18,2.2a49.32,49.32,0,0,0,8.15,4.46,46.45,46.45,0,0,0,4.79,1.79,15.43,15.43,0,0,0,4,.87,4.75,4.75,0,0,0,2.63-.66c.55-.34.77-.65.81-.62s-.15.37-.7.79a4.6,4.6,0,0,1-2.74.86,14.39,14.39,0,0,1-4.18-.79,43,43,0,0,1-13-6.39c-1-.71-1.72-1.33-2.23-1.77A4,4,0,0,1,178.32,116Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '190.10256481170654px 120.84382677078247px',
          }}
          id="elk0ubryn1rv"
          className="animable"
        />
        <path
          d="M175.58,104.5a4,4,0,0,1-.1-1.27,10,10,0,0,1,.63-3.41A6.86,6.86,0,0,1,179.53,96a5.46,5.46,0,0,1,3.07-.55,5.13,5.13,0,0,1,3,1.48,6.58,6.58,0,0,1,1.7,2.87,8.14,8.14,0,0,1,.22,3.08,12.31,12.31,0,0,1-1.74,4.85,27.18,27.18,0,0,1-2,2.83,5.73,5.73,0,0,1-.84,1,7.05,7.05,0,0,1,.68-1.08c.45-.67,1.13-1.63,1.83-2.89a12.56,12.56,0,0,0,1.59-4.72,7.74,7.74,0,0,0-.24-2.89,6.35,6.35,0,0,0-1.57-2.64,4.77,4.77,0,0,0-2.7-1.35,5.07,5.07,0,0,0-2.79.48,6.61,6.61,0,0,0-3.29,3.53,11.08,11.08,0,0,0-.77,3.29A12,12,0,0,1,175.58,104.5Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '181.52242422103882px 103.48778343200684px',
          }}
          id="elzx8y39a3zsf"
          className="animable"
        />
        <path
          d="M279.36,83.45c-1.48-.75-5.75,7.19-5.82,5s6.34-9.09,4.76-9.81c-2.06-.94-6.37,7.45-6.78,8.13s-1.42.11-1-.49c.59-.86,6.55-10,4.54-11-1.12-.52-1.86,1.57-1.86,1.57s-4.95,9-5.89,8.5,1.78-5.85,2.83-7.59.63-2.92-.51-2.75c-.78.12-4.12,5.39-5.11,7.14s-3.64,6.6-4.28,3.15-2.44-5.86-3.37-6.18a1.11,1.11,0,0,0-1.1,1.77,12.68,12.68,0,0,1,1.3,3.29,8.46,8.46,0,0,1,.3,2.83c-.08,1.1-.19,2-.3,2.83l-1.95,4.09S241,126.08,238.59,130.72s-22,24.92-22,24.92l4.13,23.73L252.47,145l16.77-47.2.41-1.17s6-6.39,7.52-8.43C280.28,84,279.91,83.73,279.36,83.45Z"
          style={{
            fill: 'rgb(183, 136, 118)',
            transformOrigin: '248.16003608703613px 127.18186569213867px',
          }}
          id="elxmw7qwblu3"
          className="animable"
        />
        <path
          d="M162.11,242.62s-10,22.6-12.14,45L139.4,431.29,174.67,435,185,286.07s32.36,150.27,33.63,150.27,28.39-10.1,28.39-10.1L215.12,243.35Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '193.20999908447266px 339.4800109863281px',
          }}
          id="elhq6oep9w9zj"
          className="animable"
        />
        <path
          d="M200,289.73c0,.17-7.19-1.43-16-3.57s-15.86-4-15.81-4.19,7.18,1.42,16,3.56S200,289.55,200,289.73Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '184.09487438201904px 285.8485884666443px',
          }}
          id="elchxmmuuy01k"
          className="animable"
        />
        <path
          d="M176.73,403.9s-.12,0-.37.07a9.09,9.09,0,0,1-1.07.1,20.77,20.77,0,0,1-3.94-.24,39,39,0,0,1-5.69-1.38c-2.1-.66-4.37-1.49-6.76-2.28a40,40,0,0,0-6.89-1.65,21,21,0,0,0-5.75,0,18.29,18.29,0,0,0-5.06,1.61,1.3,1.3,0,0,1,.3-.22,8.4,8.4,0,0,1,.93-.54,13.1,13.1,0,0,1,3.77-1.21,20.29,20.29,0,0,1,5.87-.07,37.72,37.72,0,0,1,7,1.64l6.75,2.31a41.21,41.21,0,0,0,5.6,1.47A34,34,0,0,0,176.73,403.9Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '158.96500396728516px 400.99621176719666px',
          }}
          id="ell9ffvdefvxe"
          className="animable"
        />
        <path
          d="M176.87,391.78a10.46,10.46,0,0,1-1.44,0,31.39,31.39,0,0,0-3.91.11c-3.3.24-7.75,1.31-12.72,2.34a47.55,47.55,0,0,1-7.12.91,24.55,24.55,0,0,1-5.85-.39,17.11,17.11,0,0,1-3.77-1.2,10.47,10.47,0,0,1-.95-.5,1.11,1.11,0,0,1-.31-.21,26.12,26.12,0,0,0,5.1,1.54c3.24.61,7.85.36,12.8-.66s9.45-2.05,12.8-2.19a24.27,24.27,0,0,1,3.94.05A6,6,0,0,1,176.87,391.78Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '158.83499145507812px 393.3237489461899px',
          }}
          id="elh1tysqncn0d"
          className="animable"
        />
        <path
          d="M239.76,377.75a1.12,1.12,0,0,1-.19.32,5.7,5.7,0,0,1-.7.82,8.87,8.87,0,0,1-3.4,2,14.67,14.67,0,0,1-5.81.61c-2.2-.16-4.56-.69-7-1.1a23.42,23.42,0,0,0-7-.19,22.24,22.24,0,0,0-5.53,1.47,35.51,35.51,0,0,0-4.69,2.48s.08-.1.26-.26.47-.38.85-.64a19,19,0,0,1,3.43-1.92,21.1,21.1,0,0,1,5.62-1.6,22.68,22.68,0,0,1,7.14.15c2.5.41,4.83.95,7,1.13a14.83,14.83,0,0,0,5.66-.48,9.27,9.27,0,0,0,3.37-1.79C239.42,378.14,239.72,377.72,239.76,377.75Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '222.5999984741211px 380.954261302948px',
          }}
          id="elav21lp0ig"
          className="animable"
        />
        <path
          d="M245.09,404.23a6.33,6.33,0,0,1-.93,1.1,22.86,22.86,0,0,1-2.93,2.62,27.87,27.87,0,0,1-11.83,5.17,28.58,28.58,0,0,1-12.89-.7,25.32,25.32,0,0,1-3.69-1.38,6.37,6.37,0,0,1-1.26-.7,10.51,10.51,0,0,1,1.34.51,31.27,31.27,0,0,0,3.7,1.22,29.8,29.8,0,0,0,12.71.53,29.14,29.14,0,0,0,11.7-4.94C243.68,405.73,245,404.15,245.09,404.23Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '228.32500457763672px 408.8882460594177px',
          }}
          id="elt9zx8zz6qr"
          className="animable"
        />
        <path
          d="M236.34,366.72s-.5,0-1.39,0a10.49,10.49,0,0,0-3.66.85,20.17,20.17,0,0,0-4.75,2.95c-1.66,1.33-3.38,2.95-5.42,4.39a14.4,14.4,0,0,1-6.47,2.66,21.22,21.22,0,0,1-5.71,0c-1.61-.2-2.9-.47-3.78-.66a7.89,7.89,0,0,1-1.37-.35,6.51,6.51,0,0,1,1.4.16c.9.12,2.19.33,3.79.48a22.1,22.1,0,0,0,5.6-.08,14.3,14.3,0,0,0,6.25-2.62c2-1.41,3.72-3,5.41-4.33a19.22,19.22,0,0,1,4.92-2.92,9.72,9.72,0,0,1,3.79-.71,6.35,6.35,0,0,1,1,.12A1.08,1.08,0,0,1,236.34,366.72Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '220.06499481201172px 372.1510319709778px',
          }}
          id="elsev4fmqz3j"
          className="animable"
        />
        <path
          d="M179.87,361s-.1.09-.32.22a8.48,8.48,0,0,1-1,.5,13.12,13.12,0,0,1-3.94,1,21.71,21.71,0,0,1-6-.27,57,57,0,0,1-7.13-1.81,63.29,63.29,0,0,0-7.05-1.85,23.18,23.18,0,0,0-5.9-.41,18.07,18.07,0,0,0-5.28,1.33,1.2,1.2,0,0,1,.33-.21,7.71,7.71,0,0,1,1-.5,13.41,13.41,0,0,1,3.94-1,21.8,21.8,0,0,1,6,.3,58.9,58.9,0,0,1,7.13,1.82,61.56,61.56,0,0,0,7,1.84,23,23,0,0,0,5.9.38A17.58,17.58,0,0,0,179.87,361Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '161.55998992919922px 360.3652603626251px',
          }}
          id="el9zt8pypmxcr"
          className="animable"
        />
        <path
          d="M231.62,336.41s0,.14-.1.38a7.23,7.23,0,0,1-.43,1,11.33,11.33,0,0,1-2.52,3.22,16.86,16.86,0,0,1-5.18,3.14,31.48,31.48,0,0,1-7.21,1.69c-2.6.34-5.08.56-7.31.9a47.62,47.62,0,0,0-5.88,1.05,10.11,10.11,0,0,0-3.53,1.83,13.84,13.84,0,0,1-1.13,1,1.32,1.32,0,0,1,.23-.31,8.6,8.6,0,0,1,.77-.8,9.55,9.55,0,0,1,3.54-2,40.92,40.92,0,0,1,5.93-1.17c2.24-.38,4.73-.6,7.31-1a33,33,0,0,0,7.11-1.62,17.3,17.3,0,0,0,5.11-3A13.47,13.47,0,0,0,231.62,336.41Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '214.9749984741211px 343.51499938964844px',
          }}
          id="elwrj7vmlih3"
          className="animable"
        />
        <path
          d="M145.44,333.52a19.9,19.9,0,0,0,5,2.34,15.65,15.65,0,0,0,5.94.52,18.73,18.73,0,0,0,6.9-2.37c2.31-1.24,4.44-2.6,6.56-3.54a15.94,15.94,0,0,1,5.93-1.49,9.08,9.08,0,0,1,4.07.71,6,6,0,0,1,1,.56,1.24,1.24,0,0,1,.31.24c0,.05-.47-.26-1.36-.61a9.53,9.53,0,0,0-4-.54,16.29,16.29,0,0,0-5.75,1.56c-2.06,1-4.18,2.32-6.52,3.57a18.37,18.37,0,0,1-7.1,2.38,15.4,15.4,0,0,1-6.08-.63,14.35,14.35,0,0,1-3.73-1.76,8,8,0,0,1-.9-.67C145.52,333.62,145.43,333.53,145.44,333.52Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '163.2946262359619px 332.94347763061523px',
          }}
          id="elzii7rzjfag"
          className="animable"
        />
        <path
          d="M225.94,307.23a7.09,7.09,0,0,1-.78,1.26,22.28,22.28,0,0,1-2.7,3,23.06,23.06,0,0,1-11.91,5.74,28.67,28.67,0,0,1-7.34,0,23.85,23.85,0,0,0-5.9.06,10.25,10.25,0,0,0-3.71,1.32c-.8.5-1.17.88-1.2.85s.07-.12.24-.3a7.8,7.8,0,0,1,.85-.72,9.76,9.76,0,0,1,3.75-1.51,22.42,22.42,0,0,1,6-.18,29.78,29.78,0,0,0,7.23-.08,23.58,23.58,0,0,0,11.75-5.5A36.76,36.76,0,0,0,225.94,307.23Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '209.16735458374023px 313.3458466529846px',
          }}
          id="el0ib2d3nrnw1"
          className="animable"
        />
        <path
          d="M181.32,304.72a19.67,19.67,0,0,0-5.07-1,15,15,0,0,0-5.48.89c-1,.35-2,.91-3.05,1.35a6.39,6.39,0,0,1-1.78.47,4.42,4.42,0,0,1-1.9-.25,16.84,16.84,0,0,1-3.16-1.81,13.75,13.75,0,0,0-3-1.39,14.71,14.71,0,0,0-5.5-.73,19.71,19.71,0,0,0-5,1.11s.1-.08.31-.19a7.32,7.32,0,0,1,1-.43,13.8,13.8,0,0,1,3.75-.86,14.65,14.65,0,0,1,5.67.64,13.8,13.8,0,0,1,3.09,1.42,17.53,17.53,0,0,0,3.06,1.75,4.48,4.48,0,0,0,3.32-.2c1.05-.42,2-1,3.08-1.33a14.73,14.73,0,0,1,5.65-.81,13.77,13.77,0,0,1,3.78.74,8.34,8.34,0,0,1,1,.4C181.22,304.64,181.33,304.7,181.32,304.72Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '164.35032272338867px 304.1379120349884px',
          }}
          id="elsabdamecxvc"
          className="animable"
        />
        <path
          d="M225.94,301.13a8,8,0,0,1-1.08,1.09,31.22,31.22,0,0,1-3.22,2.68c-.72.51-1.5,1.1-2.4,1.62-.45.27-.9.57-1.38.84l-1.52.79a34.89,34.89,0,0,1-7.17,2.61,33.9,33.9,0,0,1-7.58.86l-1.71-.05c-.56,0-1.09-.1-1.61-.14-1.05-.07-2-.28-2.87-.42a31.63,31.63,0,0,1-4.06-1,9.76,9.76,0,0,1-1.44-.54c0-.11,2.1.63,5.56,1.22.87.12,1.82.3,2.85.35.51,0,1,.1,1.59.11l1.69,0a35.4,35.4,0,0,0,7.46-.88,36.6,36.6,0,0,0,7.07-2.54l1.51-.76c.49-.26.94-.55,1.39-.81.9-.49,1.67-1.07,2.41-1.55,1.43-1,2.56-1.88,3.3-2.53A8.93,8.93,0,0,1,225.94,301.13Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '207.92000579833984px 306.3749694824219px',
          }}
          id="el7ddp7khi8p8"
          className="animable"
        />
        <path
          d="M219.87,272.51a3.68,3.68,0,0,1-.65.4l-1.92,1c-1.68.87-4.11,2.14-7.24,3.46a41.9,41.9,0,0,1-11.47,3.18,27.5,27.5,0,0,1-7.06-.12,40.46,40.46,0,0,1-7.31-2c-4.87-1.77-9.33-3.88-13.65-5a32.67,32.67,0,0,0-11.7-.92,33.91,33.91,0,0,0-7.77,1.72c-.89.32-1.57.58-2,.77a5.2,5.2,0,0,1-.72.27A4.51,4.51,0,0,1,149,275c.44-.23,1.12-.52,2-.87a31.79,31.79,0,0,1,7.8-1.9,32.72,32.72,0,0,1,11.87.82c4.37,1.11,8.86,3.21,13.69,5a41,41,0,0,0,7.22,1.95,27,27,0,0,0,6.93.16,42.84,42.84,0,0,0,11.38-3.05c3.13-1.27,5.58-2.48,7.29-3.3l2-.95A5.14,5.14,0,0,1,219.87,272.51Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '184.12500762939453px 276.36983156204224px',
          }}
          id="elbn48ok1fkxa"
          className="animable"
        />
        <path
          d="M217.79,257.6a10.17,10.17,0,0,0-1.88-1.75,12.06,12.06,0,0,0-6.7-1.76,14.07,14.07,0,0,0-4.74.83c-1.65.59-3.37,1.34-5.17,2.16a61.21,61.21,0,0,1-12.09,4.58,46,46,0,0,1-30-2.73c-.77-.36-1.34-.66-1.74-.86a3,3,0,0,1-.58-.34,3.28,3.28,0,0,1,.63.24l1.77.78A53.82,53.82,0,0,0,164,261a47.91,47.91,0,0,0,10.37,1.46,47.05,47.05,0,0,0,12.73-1.3,63,63,0,0,0,12-4.5c1.81-.81,3.55-1.56,5.23-2.13a13.84,13.84,0,0,1,4.88-.8,12,12,0,0,1,6.81,2,7,7,0,0,1,1.4,1.35A3.82,3.82,0,0,1,217.79,257.6Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '186.3399887084961px 258.36884927749634px',
          }}
          id="elqtfei3y511j"
          className="animable"
        />
        <path
          d="M237.93,164.76l-14.06-18.48-.62.45-22.43,14.12-23.94.83s-16.79,0-23.09,13.23c-.69,1.45-14.48,29-14.48,29l21.29,7.81,3.45-9.84,4.4,22.32-6.34,18.4,53.36,2.86L211,218.74l4-32Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '188.62000274658203px 195.86998748779297px',
          }}
          id="eljnrm649o98"
          className="animable"
        />
        <path
          d="M200.78,207.85a5.69,5.69,0,0,1,0,1.54,14.6,14.6,0,0,1-1,4.08,19.87,19.87,0,0,1-9.34,10,27.61,27.61,0,0,1-13.48,2.7,30,30,0,0,1-4.17-.43,6.17,6.17,0,0,1-1.49-.35c0-.12,2.17.29,5.67.32a28.83,28.83,0,0,0,13.17-2.82,20.14,20.14,0,0,0,9.22-9.57A23.7,23.7,0,0,0,200.78,207.85Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '186.06616687774658px 217.03008937835693px',
          }}
          id="el8yw2l3ebi6f"
          className="animable"
        />
        <path
          d="M168.66,225.23c-.18,0-2.74-11.55-5.72-25.87s-5.26-26-5.08-26,2.73,11.55,5.72,25.87S168.84,225.19,168.66,225.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '163.26002311706543px 199.2949981689453px',
          }}
          id="elwqn2f4wh1rh"
          className="animable"
        />
        <g id="eloy10u4nwaxd">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '186.3155460357666px 218.93652772903442px',
            }}
            className="animable"
          >
            <path
              d="M175.24,226.15c-.58-2.1,1.06-4.25,3-5.19s4.21-1.06,6.33-1.56a17.78,17.78,0,0,0,10.29-6.85c.33-.47.73-1,1.3-1a1.24,1.24,0,0,1,1.17,1,4.09,4.09,0,0,1,.1,2c-1,5.12-5.13,7.26-9.36,9.53s-7.62,2.49-12.86,2.07"
              id="elmf3bnkew14"
              style={{
                transformOrigin: '186.3155460357666px 218.93652772903442px',
              }}
              className="animable"
            />
          </g>
        </g>
      </g>
      <defs>
        {' '}
        <filter id="active" height="200%">
          {' '}
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />{' '}
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />{' '}
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />{' '}
          <feMerge>
            {' '}
            <feMergeNode in="OUTLINE" /> <feMergeNode in="SourceGraphic" />{' '}
          </feMerge>{' '}
        </filter>{' '}
        <filter id="hover" height="200%">
          {' '}
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />{' '}
          <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />{' '}
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />{' '}
          <feMerge>
            {' '}
            <feMergeNode in="OUTLINE" /> <feMergeNode in="SourceGraphic" />{' '}
          </feMerge>{' '}
          <feColorMatrix
            type="matrix"
            values="0   0   0   0   0                0   1   0   0   0                0   0  0   0 "
          />{' '}
        </filter>
      </defs>
    </svg>
  );
};

export default SupportIcon;

SupportIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
